import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.provisioning.rack');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-provisioning-rack',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.provisioning.rack/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
  min-height: 0;
}

.rack-view-page {
  min-width: 0;
}

.rack-view-mode-badge {
  display: inline-flex;
  height: 20px;
  align-items: center;
  gap: 4px;
  border-radius: 9999px;
  padding: 0 8px;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

.rack-view-mode-badge.is-overview {
  background: #eff6ff;
  color: #2563eb;
}

.rack-view-mode-badge.is-detail {
  background: #fffbeb;
  color: #d97706;
}

.rack-return-overview-button {
  display: inline-flex;
  height: 36px;
  align-items: center;
  gap: 6px;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  background: #fff;
  padding: 0 12px;
  color: #4f46e5;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  transition: 0.15s ease;
}

.rack-return-overview-button:hover {
  border-color: #818cf8;
  background: #eef2ff;
}

.rack-filter-field {
  display: flex;
  height: 40px;
  min-width: 210px;
  align-items: center;
  gap: 10px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
  padding: 0 10px 0 12px;
  color: #71717a;
  font-size: 11px;
  font-weight: 600;
}

.rack-filter-field select {
  min-width: 0;
  flex: 1;
  border: 0;
  background: transparent;
  color: #27272a;
  font-size: 12px;
  font-weight: 500;
  outline: none;
}

.rack-overview-top-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 245px;
  gap: 12px;
  align-items: start;
}

.rack-group-overview-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px;
  gap: 14px;
  align-items: center;
}

.rack-group-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(145px, 1fr));
  gap: 12px;
}

.rack-overall-status {
  min-width: 0;
  padding: 12px 4px;
}

.rack-overall-status > p {
  color: #27272a;
  font-size: 11px;
  font-weight: 700;
}

.rack-overall-status-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  margin-top: 14px;
}

.rack-overall-status-list > span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #52525b;
  font-size: 10px;
}

.rack-overall-status-list strong {
  color: #18181b;
  font-size: 11px;
}

.rack-overall-status-list small {
  color: #71717a;
  font-size: 9px;
}

.rack-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
}

.rack-status-normal {
  background: #22c55e;
}

.rack-status-error {
  background: #ef4444;
}

.rack-status-empty {
  background: #a1a1aa;
}

.rack-overview-layout {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr) 245px;
  gap: 12px;
  align-items: start;
}

.rack-detail-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 245px;
  gap: 12px;
  align-items: start;
}

.rack-navigator,
.rack-side-card {
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.rack-tree-zone {
  display: flex;
  width: 100%;
  align-items: center;
  border-radius: 8px;
  color: #4338ca;
  font-size: 11px;
  font-weight: 600;
  transition: 0.15s ease;
}

.rack-tree-zone:hover {
  background: #f5f3ff;
}

.rack-tree-zone.is-selected {
  background: #eef2ff;
  box-shadow: inset 0 0 0 1px #c7d2fe;
}

.rack-tree-zone-toggle {
  display: inline-flex;
  width: 30px;
  height: 42px;
  flex: none;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  color: #a1a1aa;
  transition: 0.15s ease;
}

.rack-tree-zone-toggle:hover,
.rack-tree-zone-toggle:focus-visible {
  background: #e0e7ff;
  color: #4f46e5;
  outline: none;
}

.rack-tree-zone-select {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  gap: 6px;
  padding: 7px 7px 7px 0;
  color: inherit;
  text-align: left;
}

.rack-tree-zone-select:focus-visible {
  border-radius: 7px;
  outline: 2px solid #a5b4fc;
  outline-offset: -2px;
}

.rack-tree-root {
  margin-bottom: 4px;
  color: #312e81;
}

.rack-tree-root-branch {
  position: relative;
  margin-left: 14px;
  border-left: 1px solid #c7d2fe;
  padding-left: 6px;
}

.rack-tree-root-branch > .rack-tree-zone-section {
  position: relative;
}

.rack-tree-root-branch > .rack-tree-zone-section::before {
  position: absolute;
  top: 21px;
  left: -6px;
  width: 6px;
  border-top: 1px solid #c7d2fe;
  content: "";
}

.rack-tree-zone-section + .rack-tree-zone-section {
  margin-top: 4px;
  border-top: 1px solid #f4f4f5;
  padding-top: 4px;
}

.rack-tree-zone-select small {
  color: #a1a1aa;
  font-size: 9px;
  font-weight: 400;
}

.rack-tree-count {
  min-width: 22px;
  border-radius: 9999px;
  background: #eef2ff;
  padding: 2px 5px;
  color: #6366f1;
  text-align: center;
  font-size: 9px;
  font-weight: 700;
}

.rack-tree-branch {
  position: relative;
  margin-left: 19px;
  border-left: 1px solid #e4e4e7;
  padding: 2px 0 3px 11px;
}

.rack-tree-rack {
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 7px;
  border-radius: 6px;
  padding: 6px 7px;
  color: #71717a;
  text-align: left;
  font-size: 10px;
  transition: 0.15s ease;
}

.rack-tree-rack::before {
  position: absolute;
  top: 50%;
  left: -12px;
  width: 9px;
  border-top: 1px solid #e4e4e7;
  content: "";
}

.rack-tree-rack:hover,
.rack-tree-rack.is-active {
  background: #eef2ff;
  color: #4f46e5;
}

.rack-tree-rack > .bx {
  flex: none;
  color: #a1a1aa;
  font-size: 13px;
}

.rack-tree-rack:hover > .bx,
.rack-tree-rack.is-active > .bx {
  color: #6366f1;
}

.rack-tree-status {
  width: 6px;
  height: 6px;
  flex: none;
  border-radius: 9999px;
}

.rack-tree-empty {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 7px;
  color: #a1a1aa;
  font-size: 10px;
}

.rack-tree-page-button {
  display: inline-flex;
  width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  color: #71717a;
  transition: 0.15s ease;
}

.rack-tree-page-button:hover:not(:disabled) {
  border-color: #c7d2fe;
  background: #eef2ff;
  color: #4f46e5;
}

.rack-tree-page-button:disabled {
  cursor: not-allowed;
  opacity: 0.35;
}

.rack-side-card {
  padding: 14px;
}

.rack-side-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-bottom: 1px solid #f4f4f5;
  padding-bottom: 10px;
  color: #18181b;
  font-size: 12px;
  font-weight: 700;
}

.rack-stat-list {
  margin-top: 4px;
}

.rack-stat-list > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #f4f4f5;
  padding: 10px 0;
}

.rack-stat-list > div:last-child {
  border-bottom: 0;
  padding-bottom: 2px;
}

.rack-stat-list dt {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #71717a;
  font-size: 10px;
  font-weight: 500;
}

.rack-stat-list dt i {
  color: #64748b;
  font-size: 14px;
}

.rack-stat-list dd {
  margin: 0;
  color: #18181b;
  font-size: 11px;
  font-weight: 700;
}

.rack-stat-list dt i.rack-power-icon {
  display: inline-flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  font-size: 12px;
}

.rack-stat-list dt i.rack-power-icon-on {
  background: #dcfce7;
  color: #16a34a;
}

.rack-stat-list dt i.rack-power-icon-off {
  background: #f1f5f9;
  color: #64748b;
}

.rack-stat-list dt i.rack-power-icon-fault {
  background: #fee2e2;
  color: #dc2626;
}

.rack-stat-list dt i.rack-power-icon-network {
  background: #dbeafe;
  color: #2563eb;
}

.rack-power-value {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
}

.rack-stat-list dd.rack-power-value-network {
  color: #2563eb;
}

.rack-power-value small {
  color: #71717a;
  font-size: 9px;
  font-weight: 500;
}

.rack-deployment-summary {
  min-width: 0;
}

.rack-job-status {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  padding: 3px 7px;
  font-size: 9px;
  font-weight: 700;
}

.rack-job-status.is-completed {
  background: #dcfce7;
  color: #15803d;
}

.rack-job-status.is-running {
  background: #dbeafe;
  color: #1d4ed8;
}

.rack-job-status.is-ready {
  background: #cffafe;
  color: #0e7490;
}

.rack-job-status.is-new {
  background: #f1f5f9;
  color: #64748b;
}

.rack-job-status.is-failed {
  background: #fee2e2;
  color: #dc2626;
}

.rack-job-title {
  overflow: hidden;
  margin-top: 11px;
  color: #27272a;
  font-size: 11px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rack-job-progress-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-top: 12px;
  color: #71717a;
  font-size: 10px;
}

.rack-job-progress-head strong {
  color: #18181b;
  font-size: 17px;
}

.rack-deployment-progress {
  display: flex;
  height: 8px;
  overflow: hidden;
  margin-top: 7px;
  border-radius: 9999px;
  background: #e4e4e7;
}

.rack-progress-segment {
  min-width: 2px;
}

.rack-progress-segment.is-deployed {
  background: #16a34a;
}

.rack-progress-segment.is-deploying {
  background: #2563eb;
}

.rack-progress-segment.is-ready {
  background: #06b6d4;
}

.rack-progress-segment.is-waiting {
  background: #94a3b8;
}

.rack-progress-segment.is-failed {
  background: #ef4444;
}

.rack-job-meta {
  margin-top: 8px;
}

.rack-job-meta > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-top: 7px;
  color: #71717a;
  font-size: 9px;
}

.rack-job-meta dd {
  overflow: hidden;
  max-width: 145px;
  margin: 0;
  color: #3f3f46;
  font-weight: 700;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rack-job-detail-button {
  display: flex;
  width: 100%;
  height: 32px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 11px;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  background: #fff;
  color: #4f46e5;
  font-size: 10px;
  font-weight: 700;
  transition: 0.15s ease;
}

.rack-job-detail-button:hover {
  border-color: #818cf8;
  background: #eef2ff;
}

.rack-page-button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e4e7;
  border-radius: 7px;
  background: #fff;
  color: #52525b;
  font-size: 16px;
  transition: 0.15s ease;
}

.rack-page-button:hover:not(:disabled) {
  border-color: #c7d2fe;
  background: #eef2ff;
  color: #4f46e5;
}

.rack-page-button:disabled {
  cursor: not-allowed;
  opacity: 0.35;
}

.rack-page-size-select {
  width: 88px;
  min-width: 88px;
  padding: 0 30px 0 10px;
}

.rack-toolbar-group {
  display: inline-flex;
  height: 36px;
  align-items: center;
  overflow: hidden;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
}

.rack-toolbar-group button {
  display: inline-flex;
  width: 36px;
  height: 100%;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #e4e4e7;
  color: #71717a;
  font-size: 17px;
  transition: 0.15s ease;
}

.rack-toolbar-group button:last-child {
  border-right: 0;
}

.rack-toolbar-group button:hover:not(:disabled),
.rack-toolbar-group button.is-active {
  background: #eef2ff;
  color: #4f46e5;
}

.rack-toolbar-group button:disabled {
  cursor: not-allowed;
  opacity: 0.35;
}

.rack-zoom-value {
  min-width: 50px;
  color: #52525b;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
}

.rack-zoom-surface {
  transform-origin: top left;
}

.rack-overview-grid {
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
}

.rack-overview-zone-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.rack-overview-zone-section {
  overflow: hidden;
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  background: #fafafa;
}

.rack-overview-zone-header {
  display: flex;
  min-height: 52px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e4e4e7;
  background: #fff;
  padding: 10px 12px;
}

.rack-overview-zone-count {
  flex: none;
  border-radius: 9999px;
  background: #eef2ff;
  padding: 3px 8px;
  color: #4f46e5;
  font-size: 9px;
  font-weight: 700;
}

.rack-overview-zone-section .rack-overview-grid {
  padding: 12px;
}

.rack-overview-zone-empty {
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #a1a1aa;
  font-size: 10px;
}

.rack-summary-chip {
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fafafa;
  padding: 3px 7px;
  color: #71717a;
  font-size: 9px;
  font-weight: 600;
}

.rack-detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 10px;
}

.rack-detail-grid-compact {
  grid-template-columns: repeat(auto-fill, minmax(205px, 1fr));
}

.rack-detail-card {
  min-width: 0;
  overflow: hidden;
  border-width: 1px;
  border-style: solid;
  border-radius: 9px;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.rack-detail-card:hover {
  border-color: #a5b4fc;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.rack-cabinet {
  position: relative;
  overflow: hidden;
  border: 1px solid #d4d4d8;
  border-radius: 5px;
  background: #fafafa;
}

.rack-unit-grid {
  position: absolute;
  inset: 0;
  display: grid;
  grid-template-rows: repeat(42, 11px);
}

.rack-unit-line {
  position: relative;
  border-bottom: 1px solid #eceef2;
}

.rack-unit-line b {
  position: absolute;
  top: 0;
  left: 2px;
  width: 15px;
  color: #a1a1aa;
  font-size: 7px;
  font-weight: 500;
  line-height: 10px;
}

.rack-item-layer {
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  left: 18px;
}

.rack-mounted-item {
  position: absolute;
  right: 0;
  left: 0;
  display: flex;
  min-height: 10px;
  align-items: center;
  gap: 3px;
  overflow: hidden;
  border: 1px solid;
  border-radius: 3px;
  padding: 0 3px;
  text-align: left;
  font-size: 7px;
  font-weight: 600;
  line-height: 1;
  transition: filter 0.15s ease, transform 0.15s ease;
}

.rack-mounted-item:hover {
  z-index: 5;
  filter: brightness(0.97);
  transform: translateX(-1px);
}

.rack-mounted-item i {
  flex: none;
  font-size: 8px;
}

.rack-mounted-item span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rack-device-on {
  border-color: #86efac;
  background: #dcfce7;
  color: #166534;
}

.rack-device-off {
  border-color: #d4d4d8;
  background: #f4f4f5;
  color: #52525b;
}

.rack-device-fault {
  border-color: #fca5a5;
  background: #fee2e2;
  color: #b91c1c;
}

.rack-device-network {
  border-color: #93c5fd;
  background: #dbeafe;
  color: #1d4ed8;
}

.rack-device-chassis {
  border-color: #a5b4fc;
  background: #e0e7ff;
  color: #4338ca;
}

.rack-mounted-item.rack-chassis-monitor-item {
  display: block;
  padding: 1px 3px;
}

.rack-chassis-monitor {
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
  gap: 1px;
  overflow: hidden;
}

.rack-chassis-monitor-head {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 3px;
  font-size: 6px;
  line-height: 7px;
}

.rack-chassis-monitor-head b {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rack-chassis-monitor-head small {
  flex: none;
  font-size: 5px;
  font-weight: 700;
  white-space: nowrap;
}

.rack-chassis-slots {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
  overflow: hidden;
  color: #475569;
  line-height: 6px;
}

.rack-chassis-slot {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 1px;
  overflow: visible;
  font-size: 5px;
  font-weight: 700;
  white-space: nowrap;
}

.rack-mounted-item .rack-chassis-slot i {
  width: 5px;
  height: 5px;
  flex: none;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 0;
}

.rack-chassis-slot.is-deployed i {
  background: #16a34a;
}

.rack-chassis-slot.is-ready i {
  background: #06b6d4;
}

.rack-chassis-slot.is-deploying i {
  background: #2563eb;
}

.rack-chassis-slot.is-waiting i {
  background: #94a3b8;
}

.rack-chassis-slot.is-failed i {
  background: #ef4444;
}

.rack-chassis-slot.is-empty i {
  border-color: #cbd5e1;
  background: #fff;
}

.rack-minimap-launch {
  display: block;
  width: 100%;
  overflow: hidden;
  border: 1px solid #dbe3ef;
  border-radius: 9px;
  background: #f8fafc;
  padding: 0;
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.rack-minimap-launch:hover {
  border-color: #a5b4fc;
  box-shadow: 0 0 0 2px #e0e7ff;
}

.rack-minimap-viewport {
  position: relative;
  width: 100%;
  height: 150px;
  overflow: hidden;
  background-color: #0f172a;
  background-image: linear-gradient(rgba(51, 65, 85, 0.45) 1px, transparent 1px), linear-gradient(90deg, rgba(51, 65, 85, 0.45) 1px, transparent 1px);
  background-size: 12px 12px;
  pointer-events: none;
}

.rack-minimap-stage {
  position: absolute;
  border: 1px solid #94a3b8;
  background-color: #f8fafc;
  background-position: center;
  background-repeat: no-repeat, no-repeat, repeat;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
  transform-origin: top left;
}

.rack-minimap-zone {
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.1);
}

.rack-canvas-object.rack-minimap-object {
  box-shadow: none;
  pointer-events: none;
}

.rack-minimap-badge {
  position: absolute;
  top: 7px;
  left: 7px;
  z-index: 10;
  max-width: calc(100% - 42px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 9999px;
  background: rgba(15, 23, 42, 0.82);
  padding: 3px 7px;
  color: #e2e8f0;
  font-size: 8px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rack-minimap-expand {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  color: #fff;
  font-size: 15px;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.5));
}

.rack-minimap-caption {
  display: flex;
  height: 29px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  color: #4f46e5;
  font-size: 9px;
  font-weight: 700;
}

.rack-spatial-overlay {
  outline: none;
}

.rack-canvas-scope {
  display: inline-flex;
  height: 34px;
  min-width: 190px;
  align-items: center;
  gap: 7px;
  border: 1px solid #475569;
  border-radius: 7px;
  background: #1e293b;
  padding: 0 9px;
  color: #a5b4fc;
}

.rack-canvas-scope select {
  min-width: 145px;
  border: 0;
  background: transparent;
  color: #e2e8f0;
  font-size: 11px;
  font-weight: 600;
  outline: 0;
}

.rack-canvas-scope select:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.rack-canvas-toolbar {
  display: inline-flex;
  height: 34px;
  align-items: center;
  overflow: hidden;
  border: 1px solid #475569;
  border-radius: 7px;
  background: #1e293b;
}

.rack-canvas-toolbar button {
  display: inline-flex;
  width: 34px;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: #cbd5e1;
}

.rack-canvas-toolbar button:hover:not(:disabled) {
  background: #334155;
  color: #fff;
}

.rack-canvas-toolbar button:disabled {
  opacity: 0.3;
}

.rack-canvas-toolbar span {
  min-width: 48px;
  color: #cbd5e1;
  text-align: center;
  font-size: 10px;
  font-weight: 700;
}

.rack-canvas-button {
  display: inline-flex;
  height: 34px;
  align-items: center;
  gap: 5px;
  border: 1px solid #475569;
  border-radius: 7px;
  background: #1e293b;
  padding: 0 10px;
  color: #cbd5e1;
  font-size: 10px;
  font-weight: 600;
  transition: 0.15s ease;
}

.rack-canvas-button:hover:not(:disabled) {
  border-color: #64748b;
  background: #334155;
  color: #fff;
}

.rack-canvas-button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.rack-canvas-button-primary {
  border-color: #6366f1;
  background: #4f46e5;
  color: #fff;
}

.rack-canvas-button-save {
  border-color: #059669;
  background: #047857;
  color: #fff;
}

.rack-canvas-change-count {
  min-width: 17px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.2);
  padding: 1px 4px;
  text-align: center;
  font-size: 8px;
}

.rack-canvas-close {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  color: #94a3b8;
  font-size: 24px;
}

.rack-canvas-close:hover {
  background: #334155;
  color: #fff;
}

.rack-spatial-viewport {
  cursor: grab;
  background-color: #020617;
}

.rack-spatial-viewport.is-panning {
  cursor: grabbing;
}

.rack-canvas-paint-tools {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 70;
  display: flex;
  width: 68px;
  flex-direction: column;
  gap: 5px;
  border: 1px solid #475569;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.96);
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.35);
  padding: 8px;
  color: #cbd5e1;
}

.rack-canvas-paint-tools-title {
  padding: 2px 0 4px;
  color: #94a3b8;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-align: center;
  text-transform: uppercase;
}

.rack-canvas-paint-tools button {
  display: flex;
  min-height: 48px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border: 1px solid transparent;
  border-radius: 8px;
  color: #cbd5e1;
  font-size: 8px;
  font-weight: 700;
}

.rack-canvas-paint-tools button i {
  font-size: 19px;
}

.rack-canvas-paint-tools button:hover:not(:disabled),
.rack-canvas-paint-tools button.is-active {
  border-color: #818cf8;
  background: rgba(79, 70, 229, 0.28);
  color: #e0e7ff;
}

.rack-canvas-paint-tools button:disabled {
  cursor: wait;
  opacity: 0.45;
}

.rack-canvas-paint-tools-divider {
  height: 1px;
  margin: 2px 3px;
  background: #334155;
}

.rack-spatial-stage {
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
  background-color: #f8fafc;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.45);
  outline: 1px solid rgba(71, 85, 105, 0.7);
  transform-origin: top left;
}

.rack-spatial-stage.is-drawing-tool {
  cursor: crosshair;
}

.rack-canvas-grid-overlay {
  position: absolute;
  inset: 0;
  z-index: 60;
  background-image: radial-gradient(circle at 0 0, rgba(129, 140, 248, 0.72) 0 1.35px, transparent 1.55px), linear-gradient(90deg, rgba(129, 140, 248, 0.2) 1px, transparent 1px), linear-gradient(rgba(129, 140, 248, 0.2) 1px, transparent 1px);
  pointer-events: none;
}

.rack-canvas-grid-control {
  display: inline-flex;
  height: 30px;
  align-items: center;
  gap: 4px;
  border: 1px solid rgba(34, 211, 238, 0.28);
  border-radius: 999px;
  background: rgba(6, 182, 212, 0.14);
  padding: 0 4px;
  color: #67e8f9;
  font-size: 10px;
  font-weight: 700;
}

.rack-canvas-grid-toggle {
  display: inline-flex;
  height: 22px;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  padding: 0 7px;
  color: #94a3b8;
  white-space: nowrap;
}

.rack-canvas-grid-toggle.is-active {
  background: rgba(8, 145, 178, 0.32);
  color: #cffafe;
}

.rack-canvas-grid-control label {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  transition: opacity 0.15s ease;
}

.rack-canvas-grid-control.is-disabled label {
  opacity: 0.58;
}

.rack-canvas-grid-control input[type=number] {
  width: 52px;
  height: 22px;
  border: 1px solid rgba(103, 232, 249, 0.3);
  border-radius: 7px;
  background: #0f172a;
  padding: 0 5px;
  color: #cffafe;
  font-size: 10px;
  font-weight: 800;
  text-align: right;
}

.rack-canvas-grid-control input[type=number]:focus {
  border-color: #67e8f9;
  outline: 2px solid rgba(34, 211, 238, 0.24);
}

.rack-canvas-object {
  position: absolute;
  z-index: 25;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  border-style: solid;
  border-radius: 5px;
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.12);
  pointer-events: none;
  transform-origin: center center;
  user-select: none;
}

.rack-canvas-object.is-behind {
  z-index: 2;
}

.rack-canvas-object.is-editable {
  pointer-events: auto;
  cursor: move;
}

.rack-canvas-object.is-selected {
  z-index: 35;
  box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.8), 0 12px 28px rgba(49, 46, 129, 0.3);
}

.rack-canvas-object[data-object-type=ellipse] {
  border-radius: 50%;
}

.rack-canvas-object[data-object-type=image] {
  overflow: visible;
  border-radius: 6px;
}

.rack-canvas-object[data-object-type=arrow] {
  box-shadow: none;
}

.rack-canvas-object[data-object-type=arrow].is-selected {
  outline: 2px dashed #818cf8;
  outline-offset: 3px;
}

.rack-canvas-object img {
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-fit: contain;
  pointer-events: none;
}

.rack-canvas-object-text {
  display: -webkit-box;
  width: 100%;
  max-height: 100%;
  overflow: hidden;
  padding: 8px;
  font-weight: 700;
  line-height: 1.25;
  overflow-wrap: anywhere;
  text-align: center;
  white-space: pre-wrap;
  -webkit-box-orient: vertical;
}

.rack-canvas-object-arrow {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
}

.rack-canvas-arrow-point {
  position: absolute;
  z-index: 4;
  width: 15px;
  height: 15px;
  border: 2px solid #4f46e5;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 3px 8px rgba(49, 46, 129, 0.35);
  cursor: crosshair;
  transform: translate(-50%, -50%);
}

.rack-canvas-arrow-point.is-end {
  background: #4f46e5;
  box-shadow: 0 0 0 3px rgba(199, 210, 254, 0.78), 0 3px 8px rgba(49, 46, 129, 0.35);
}

.rack-canvas-object-rotate {
  position: absolute;
  top: -39px;
  left: 50%;
  z-index: 4;
  display: inline-flex;
  min-width: 54px;
  height: 27px;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border: 2px solid #eef2ff;
  border-radius: 999px;
  background: #0f766e;
  box-shadow: 0 4px 10px rgba(15, 118, 110, 0.35);
  color: #fff;
  cursor: grab;
  font-size: 13px;
  transform: translateX(-50%);
}

.rack-canvas-object-rotate span {
  font-size: 9px;
  font-weight: 800;
}

.rack-canvas-object-rotate::after {
  position: absolute;
  top: 23px;
  left: 50%;
  width: 1px;
  height: 14px;
  background: #0f766e;
  content: "";
  transform: translateX(-50%);
}

.rack-canvas-object-rotate:active {
  cursor: grabbing;
}

.rack-canvas-rotation-help {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  border: 1px solid #99f6e4;
  border-radius: 9px;
  background: #f0fdfa;
  padding: 9px 10px;
  color: #0f766e;
  font-size: 9px;
  font-weight: 650;
  line-height: 1.45;
}

.rack-canvas-rotation-help i {
  margin-top: 1px;
  font-size: 14px;
}

.rack-canvas-object-resize {
  position: absolute;
  right: -9px;
  bottom: -9px;
  z-index: 3;
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border: 2px solid #eef2ff;
  border-radius: 7px;
  background: #4f46e5;
  box-shadow: 0 4px 10px rgba(49, 46, 129, 0.38);
  color: #fff;
  cursor: nwse-resize;
  font-size: 12px;
}

.rack-spatial-zone {
  position: absolute;
  z-index: 10;
  overflow: visible;
  border: 2px solid rgba(99, 102, 241, 0.6);
  border-radius: 16px;
  background: rgba(238, 242, 255, 0.86);
  box-shadow: 0 8px 30px rgba(30, 41, 59, 0.12);
  transition: box-shadow 0.12s ease, opacity 0.12s ease;
}

.rack-spatial-zone.is-dragging {
  z-index: 40;
  opacity: 0.94;
  box-shadow: 0 0 0 4px rgba(165, 180, 252, 0.72), 18px 24px 44px rgba(15, 23, 42, 0.38);
}

.rack-spatial-zone.is-selected:not(.is-dragging) {
  z-index: 30;
  box-shadow: 0 0 0 4px rgba(129, 140, 248, 0.55), 0 12px 32px rgba(49, 46, 129, 0.24);
}

.rack-spatial-zone[data-shape=soft] {
  border-radius: 7px;
}

.rack-spatial-zone[data-shape=soft] .rack-spatial-zone-header {
  border-radius: 5px 5px 0 0;
}

.rack-spatial-zone[data-shape=square] {
  border-radius: 0;
}

.rack-spatial-zone[data-shape=square] .rack-spatial-zone-header {
  border-radius: 0;
}

.rack-spatial-zone.is-unassigned {
  border-color: rgba(245, 158, 11, 0.65);
  background: rgba(255, 251, 235, 0.88);
}

.rack-spatial-zone-header {
  display: flex;
  height: 58px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid rgba(99, 102, 241, 0.25);
  border-radius: 14px 14px 0 0;
  background: rgba(255, 255, 255, 0.78);
  padding: 10px 14px;
  color: #1e293b;
  user-select: none;
}

.rack-spatial-zone-header.is-editable {
  cursor: grab;
}

.rack-spatial-zone-header.is-editable:active {
  cursor: grabbing;
}

.rack-spatial-zone-header h3 {
  font-size: 13px;
  font-weight: 700;
}

.rack-spatial-zone-header p {
  margin-top: 2px;
  color: #64748b;
  font-size: 9px;
}

.rack-spatial-zone-body {
  position: relative;
  height: calc(100% - 58px);
}

.rack-spatial-zone-open {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #4f46e5;
  font-size: 15px;
}

.rack-spatial-zone-open:hover:not(:disabled) {
  background: #e0e7ff;
}

.rack-spatial-zone-open:disabled {
  opacity: 0.35;
}

.rack-spatial-zone-empty {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: 7px;
  color: #94a3b8;
  font-size: 11px;
}

.rack-spatial-zone-size {
  position: absolute;
  right: 25px;
  bottom: 5px;
  z-index: 20;
  border: 1px solid rgba(99, 102, 241, 0.25);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  padding: 2px 7px;
  color: #4338ca;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.3;
  pointer-events: none;
  user-select: none;
}

.rack-spatial-zone-resize {
  position: absolute;
  right: -7px;
  bottom: -7px;
  z-index: 21;
  display: inline-flex;
  width: 27px;
  height: 27px;
  align-items: center;
  justify-content: center;
  border: 2px solid #eef2ff;
  border-radius: 8px;
  background: #4f46e5;
  box-shadow: 0 4px 12px rgba(49, 46, 129, 0.35);
  color: #fff;
  cursor: nwse-resize;
  font-size: 14px;
}

.rack-spatial-zone-resize:hover,
.rack-spatial-zone-resize:focus-visible {
  background: #4338ca;
  outline: 2px solid rgba(165, 180, 252, 0.8);
  outline-offset: 2px;
}

.rack-spatial-zone-resize:active {
  cursor: nwse-resize;
  transform: scale(0.94);
}

.rack-spatial-rack {
  position: absolute;
  z-index: 10;
  border: 1px solid #cbd5e1;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.1);
  transition: box-shadow 0.12s ease, opacity 0.12s ease;
}

.rack-spatial-rack-tile {
  display: flex;
  width: 124px;
  height: 78px;
  align-items: center;
  gap: 6px;
  border-radius: 9px;
  padding: 9px 8px;
}

.rack-spatial-rack-tile h4 {
  color: #1e293b;
  font-size: 10px;
  font-weight: 700;
}

.rack-spatial-rack-tile p {
  margin-top: 3px;
  color: #94a3b8;
  font-size: 8px;
}

.rack-spatial-rack.is-editable {
  border-color: #818cf8;
  box-shadow: 0 0 0 2px rgba(199, 210, 254, 0.6), 0 6px 18px rgba(15, 23, 42, 0.15);
}

.rack-spatial-rack.is-dragging {
  z-index: 40;
  opacity: 0.92;
  box-shadow: 0 0 0 3px rgba(165, 180, 252, 0.8), 12px 16px 30px rgba(15, 23, 42, 0.38);
}

.rack-spatial-rack.is-selected:not(.is-dragging) {
  z-index: 30;
  box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.62), 0 10px 24px rgba(49, 46, 129, 0.24);
}

.rack-spatial-rack[data-shape=soft] {
  border-radius: 5px;
}

.rack-spatial-rack[data-shape=square] {
  border-radius: 0;
}

.rack-spatial-rack-drag {
  display: inline-flex;
  width: 20px;
  height: 28px;
  flex: none;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  color: #94a3b8;
  cursor: default;
}

.rack-spatial-rack-drag:not(:disabled) {
  color: #6366f1;
  cursor: grab;
}

.rack-spatial-rack-drag:not(:disabled):active {
  cursor: grabbing;
}

.rack-spatial-rack-detail {
  width: 196px;
  overflow: hidden;
  border-radius: 10px;
}

.rack-spatial-rack-header {
  display: flex;
  height: 52px;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid #e2e8f0;
  padding: 7px 9px;
}

.rack-spatial-rack-header h3 {
  color: #0f172a;
  font-size: 11px;
  font-weight: 700;
}

.rack-spatial-rack-header p {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 8px;
}

.rack-spatial-rack-detail footer {
  display: flex;
  height: 28px;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #e2e8f0;
  padding: 0 9px;
  color: #64748b;
  font-size: 8px;
}

.rack-spatial-cabinet {
  position: relative;
  margin: 9px;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  background: rgba(248, 250, 252, 0.9);
}

.rack-spatial-drop-grid {
  position: absolute;
  inset: 0;
  display: grid;
  grid-auto-rows: 8px;
}

.rack-spatial-drop-unit {
  position: relative;
  border-bottom: 1px solid #e2e8f0;
}

.rack-spatial-rack.is-editable .rack-spatial-drop-unit {
  transition: background 0.1s ease;
}

.rack-spatial-rack.is-editable .rack-spatial-drop-unit:hover {
  background: #e0e7ff;
}

.rack-spatial-drop-unit span {
  position: absolute;
  top: 0;
  left: 2px;
  color: #94a3b8;
  font-size: 6px;
  line-height: 7px;
}

.rack-spatial-item-layer {
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  left: 17px;
  pointer-events: none;
}

.rack-spatial-drop-shadow {
  position: absolute;
  right: 3px;
  left: 17px;
  z-index: 8;
  display: flex;
  min-height: 7px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px dashed #4f46e5;
  border-radius: 3px;
  background: rgba(99, 102, 241, 0.24);
  box-shadow: 0 0 0 2px rgba(199, 210, 254, 0.78), 0 8px 18px rgba(49, 46, 129, 0.32);
  color: #312e81;
  font-size: 6px;
  font-weight: 800;
  line-height: 1;
  pointer-events: none;
}

.rack-spatial-mounted-item {
  position: absolute;
  right: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 3px;
  overflow: hidden;
  border: 1px solid;
  border-radius: 2px;
  padding: 0 3px;
  pointer-events: auto;
  text-align: left;
  font-size: 6px;
  font-weight: 700;
  line-height: 1;
}

.rack-spatial-mounted-item.is-draggable {
  cursor: grab;
}

.rack-spatial-mounted-item.is-draggable:active {
  cursor: grabbing;
}

.rack-spatial-mounted-item.is-dragging {
  z-index: 10;
  opacity: 0.48;
  box-shadow: 0 0 0 2px rgba(199, 210, 254, 0.85), 0 8px 16px rgba(15, 23, 42, 0.4);
}

.rack-spatial-mounted-item.is-selected:not(.is-dragging) {
  z-index: 9;
  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.82), 0 6px 12px rgba(49, 46, 129, 0.28);
}

.rack-spatial-mounted-item[data-shape=rounded] {
  border-radius: 6px;
}

.rack-spatial-mounted-item[data-shape=soft] {
  border-radius: 2px;
}

.rack-spatial-mounted-item[data-shape=square] {
  border-radius: 0;
}

.rack-spatial-mounted-item[data-shape=pill] {
  border-radius: 999px;
}

.rack-canvas-inspector {
  position: absolute;
  top: 12px;
  right: 12px;
  bottom: 12px;
  z-index: 70;
  display: flex;
  width: 304px;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: -16px 0 40px rgba(15, 23, 42, 0.28);
  color: #0f172a;
}

.rack-canvas-inspector-header {
  display: flex;
  min-height: 68px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 12px 14px;
}

.rack-canvas-inspector-header span {
  color: #6366f1;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.rack-canvas-inspector-header h3 {
  margin-top: 3px;
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rack-canvas-inspector-header button {
  display: inline-flex;
  width: 30px;
  height: 30px;
  flex: none;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  color: #64748b;
  font-size: 20px;
}

.rack-canvas-inspector-header button:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.rack-canvas-inspector-body {
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  gap: 18px;
  overflow-y: auto;
  padding: 16px;
}

.rack-canvas-inspector-field {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.rack-canvas-inspector-field > span {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #334155;
  font-size: 11px;
}

.rack-canvas-inspector-field strong,
.rack-canvas-inspector-field legend {
  color: #334155;
  font-size: 11px;
  font-weight: 800;
}

.rack-canvas-inspector-field output,
.rack-canvas-inspector-field code {
  color: #6366f1;
  font-family: inherit;
  font-size: 10px;
  font-weight: 800;
}

.rack-canvas-inspector-field input[type=range] {
  width: 100%;
  accent-color: #4f46e5;
}

.rack-canvas-text-input {
  width: 100%;
  min-height: 76px;
  resize: vertical;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  padding: 9px 10px;
  color: #1e293b;
  font-size: 11px;
  line-height: 1.45;
}

.rack-canvas-text-input:focus {
  border-color: #818cf8;
  outline: 2px solid rgba(199, 210, 254, 0.65);
  outline-offset: 1px;
}

.rack-canvas-shape-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px;
}

.rack-canvas-shape-options button {
  display: flex;
  min-height: 58px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  background: #f8fafc;
  color: #64748b;
  font-size: 9px;
  font-weight: 700;
}

.rack-canvas-shape-options button:hover,
.rack-canvas-shape-options button.is-active {
  border-color: #818cf8;
  background: #eef2ff;
  color: #4338ca;
  box-shadow: 0 0 0 2px rgba(199, 210, 254, 0.55);
}

.rack-canvas-shape-preview {
  display: block;
  width: 34px;
  height: 20px;
  border: 2px solid currentColor;
  border-radius: 7px;
  background: rgba(99, 102, 241, 0.1);
}

.rack-canvas-shape-preview[data-shape=soft] {
  border-radius: 3px;
}

.rack-canvas-shape-preview[data-shape=square] {
  border-radius: 0;
}

.rack-canvas-shape-preview[data-shape=pill] {
  border-radius: 999px;
}

.rack-canvas-color-input {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  gap: 8px;
}

.rack-canvas-color-input input[type=color] {
  width: 44px;
  height: 36px;
  cursor: pointer;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  padding: 3px;
}

.rack-canvas-color-input input[type=text] {
  width: 100%;
  height: 36px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  padding: 0 10px;
  color: #334155;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.rack-canvas-color-input input:focus {
  border-color: #818cf8;
  outline: 2px solid rgba(199, 210, 254, 0.65);
  outline-offset: 1px;
}

.rack-canvas-color-options {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 7px;
}

.rack-canvas-color-options button {
  aspect-ratio: 1;
  border: 2px solid #fff;
  border-radius: 7px;
  box-shadow: 0 0 0 1px #cbd5e1;
}

.rack-canvas-color-options button:hover,
.rack-canvas-color-options button.is-active {
  box-shadow: 0 0 0 3px #a5b4fc;
  transform: translateY(-1px);
}

.rack-canvas-layer-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.rack-canvas-layer-options button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
}

.rack-canvas-layer-options button:hover,
.rack-canvas-layer-options button.is-active {
  border-color: #818cf8;
  background: #eef2ff;
  color: #4338ca;
}

.rack-canvas-style-reset {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: auto;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 10px;
  font-weight: 800;
}

.rack-canvas-style-reset:hover {
  border-color: #a5b4fc;
  background: #eef2ff;
  color: #4338ca;
}

.rack-canvas-object-delete {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: auto;
  border: 1px solid #fecaca;
  border-radius: 8px;
  background: #fff1f2;
  color: #be123c;
  font-size: 10px;
  font-weight: 800;
}

.rack-canvas-object-delete:hover {
  border-color: #fb7185;
  background: #ffe4e6;
  color: #9f1239;
}

.rack-spatial-mounted-item i {
  flex: none;
  font-size: 7px;
}

.rack-spatial-mounted-item span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 1279px) {
  .rack-overview-top-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .rack-overview-layout {
    grid-template-columns: 200px minmax(0, 1fr);
  }
  .rack-overview-layout > aside:last-child {
    display: grid;
    grid-column: 1/-1;
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .rack-detail-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .rack-detail-layout > aside {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (max-width: 767px) {
  .rack-group-overview-row {
    grid-template-columns: minmax(0, 1fr);
  }
  .rack-overview-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .rack-navigator {
    display: none;
  }
  .rack-overview-layout > aside:last-child,
  .rack-detail-layout > aside {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }
  .rack-filter-field {
    width: 100%;
  }
}
/* Deployment / provisioning Rack View states */
.rack-status-deployed {
  background: #16a34a;
}

.rack-status-ready {
  background: #06b6d4;
}

.rack-status-deploying {
  background: #2563eb;
}

.rack-status-failed {
  background: #ef4444;
}

.rack-status-waiting {
  background: #94a3b8;
}

.rack-device-deployed {
  border-color: #86efac;
  background: #dcfce7;
  color: #166534;
}

.rack-device-ready {
  border-color: #67e8f9;
  background: #cffafe;
  color: #0e7490;
}

.rack-device-deploying {
  border-color: #93c5fd;
  background: #dbeafe;
  color: #1d4ed8;
}

.rack-device-deploy-failed {
  border-color: #fca5a5;
  background: #fee2e2;
  color: #b91c1c;
}

.rack-device-waiting {
  border-color: #cbd5e1;
  background: #f1f5f9;
  color: #64748b;
}

.rack-device-not-applicable {
  border-color: #d4d4d8;
  background: #f4f4f5;
  color: #71717a;
}

.rack-stat-list dt i.rack-power-icon-deploying {
  color: #2563eb;
  background: #dbeafe;
}

.rack-stat-list dt i.rack-power-icon-ready {
  color: #0891b2;
  background: #cffafe;
}

.rack-stat-list dt i.rack-power-icon-waiting {
  color: #64748b;
  background: #f1f5f9;
}

/* Rack View overview refresh — physical Zone/Rack + logical Relay/Compute */
.rack-global-filter {
  overflow: visible;
}

.rack-filter-field {
  min-width: 180px;
}

.rack-node-type-filter {
  display: inline-flex;
  height: 40px;
  min-width: 270px;
  align-items: center;
  gap: 2px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
  padding: 3px 4px 3px 12px;
}

.rack-node-type-filter > span {
  margin-right: 7px;
  color: #71717a;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.rack-node-type-filter button {
  height: 30px;
  min-width: 55px;
  border-radius: 6px;
  padding: 0 9px;
  color: #52525b;
  font-size: 10px;
  font-weight: 700;
  transition: 0.15s ease;
}

.rack-node-type-filter button:hover {
  background: #f4f4f5;
}

.rack-node-type-filter button.is-active {
  background: #4f46e5;
  color: #fff;
  box-shadow: 0 2px 5px rgba(79, 70, 229, 0.2);
}

.rack-overview-top-layout {
  grid-template-columns: minmax(0, 1fr) 245px;
  gap: 12px;
}

.rack-zone-overview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 10px;
}

.rack-zone-summary-card {
  min-width: 0;
  border: 1px solid #e4e4e7;
  border-radius: 9px;
  background: #fff;
  padding: 13px 14px 11px;
  text-align: left;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
  transition: 0.15s ease;
}

.rack-zone-summary-card:hover,
.rack-zone-summary-card.is-active {
  border-color: #a5b4fc;
  box-shadow: 0 3px 10px rgba(79, 70, 229, 0.09);
}

.rack-zone-summary-card.is-active {
  box-shadow: 0 0 0 2px #e0e7ff;
}

.rack-zone-summary-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.rack-zone-summary-head p {
  color: #18181b;
  font-size: 13px;
  font-weight: 800;
}

.rack-zone-summary-head span {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 4px;
  color: #64748b;
  font-size: 9px;
  font-weight: 600;
}

.rack-zone-summary-head span i {
  width: 1px;
  height: 9px;
  background: #d4d4d8;
}

.rack-zone-summary-head > i {
  color: #4f46e5;
  font-size: 18px;
}

.rack-zone-status-bar {
  display: flex;
  height: 5px;
  overflow: hidden;
  margin-top: 14px;
  border-radius: 9999px;
  background: #e4e4e7;
}

.rack-zone-status-bar > span {
  min-width: 2px;
}

.rack-zone-status-bar .is-deployed {
  background: #16a34a;
}

.rack-zone-status-bar .is-deploying {
  background: #2563eb;
}

.rack-zone-status-bar .is-ready {
  background: #0891b2;
}

.rack-zone-status-bar .is-waiting {
  background: #94a3b8;
}

.rack-zone-status-bar .is-failed {
  background: #ef4444;
}

.rack-zone-status-stats,
.rack-card-status-stats {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 3px;
  margin-top: 9px;
  font-size: 8px;
  font-weight: 700;
  white-space: nowrap;
}

.rack-zone-status-stats .is-deployed,
.rack-card-status-stats .is-deployed {
  color: #16a34a;
}

.rack-zone-status-stats .is-deploying,
.rack-card-status-stats .is-deploying {
  color: #2563eb;
}

.rack-zone-status-stats .is-ready,
.rack-card-status-stats .is-ready {
  color: #0891b2;
}

.rack-zone-status-stats .is-waiting,
.rack-card-status-stats .is-waiting {
  color: #64748b;
}

.rack-zone-status-stats .is-failed,
.rack-card-status-stats .is-failed {
  color: #ef4444;
}

.rack-zone-role-counts {
  display: flex;
  align-items: center;
  gap: 22px;
  margin-top: 12px;
  color: #64748b;
  font-size: 9px;
}

.rack-zone-role-counts strong {
  margin-left: 7px;
  color: #27272a;
  font-size: 10px;
}

.rack-overview-layout {
  grid-template-columns: 150px minmax(0, 1fr) 245px;
}

.rack-overview-grid {
  grid-template-columns: repeat(auto-fill, minmax(205px, 1fr));
}

.rack-overview-card {
  min-width: 0;
  border: 1px solid #e4e4e7;
  border-radius: 9px;
  background: #fff;
  padding: 11px 12px;
  text-align: left;
  transition: 0.15s ease;
}

.rack-overview-card:hover {
  transform: translateY(-1px);
  border-color: #a5b4fc;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.rack-card-head {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
}

.rack-card-head p {
  overflow: hidden;
  min-width: 0;
  color: #18181b;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rack-card-head span {
  border-radius: 9999px;
  background: #eef2ff;
  padding: 2px 5px;
  color: #4f46e5;
  font-size: 7px;
  font-weight: 700;
  white-space: nowrap;
}

.rack-card-head i {
  margin-left: auto;
  color: #4f46e5;
}

.rack-card-role-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  color: #27272a;
  font-size: 8px;
  font-weight: 700;
}

.rack-card-role-row strong {
  margin-left: 5px;
  font-size: 9px;
}

.rack-card-role-row small {
  margin-left: 3px;
  color: #71717a;
  font-size: 7px;
  font-weight: 600;
}

.rack-card-groups {
  display: flex;
  height: 25px;
  min-width: 0;
  align-items: center;
  gap: 6px;
  margin-top: 7px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  padding: 0 7px;
  font-size: 7px;
}

.rack-card-groups b {
  flex: none;
  color: #27272a;
}

.rack-card-groups span {
  overflow: hidden;
  min-width: 0;
  color: #52525b;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rack-card-groups i {
  margin-left: auto;
  color: #4f46e5;
}

.rack-card-status-bar {
  margin-top: 8px;
}

.rack-card-status-stats {
  font-size: 7px;
}

.rack-card-status-stats span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rack-card-status-stats small {
  display: block;
  margin-top: 2px;
  color: currentcolor;
  font-size: 6px;
  font-weight: 600;
}

.rack-node-summary-caption {
  margin-top: 7px;
  color: #71717a;
  font-size: 8px;
}

.rack-node-summary-table-wrap {
  overflow-x: auto;
  margin-top: 8px;
}

.rack-node-summary-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 7px;
}

.rack-node-summary-table th,
.rack-node-summary-table td {
  border-bottom: 1px solid #f4f4f5;
  padding: 5px 1px;
  text-align: center;
  white-space: nowrap;
}

.rack-node-summary-table thead th {
  color: #71717a;
  font-weight: 600;
}

.rack-node-summary-table tbody th {
  color: #27272a;
  font-weight: 800;
  text-align: left;
}

.rack-node-summary-table tbody td {
  color: #27272a;
  font-weight: 700;
}

.rack-node-summary-note {
  margin-top: 7px;
  color: #64748b;
  font-size: 7px;
  line-height: 1.45;
}

.rack-status-legend ul {
  display: grid;
  gap: 7px;
  margin-top: 10px;
}

.rack-status-legend li {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #52525b;
  font-size: 9px;
}

.rack-relay-role-legend {
  display: flex;
  gap: 16px;
  margin-top: 11px;
  border-top: 1px solid #f4f4f5;
  padding-top: 9px;
}

.rack-relay-role-legend span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #64748b;
  font-size: 8px;
}

.rack-relay-role-legend b {
  display: inline-flex;
  width: 17px;
  height: 17px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: #f4f4f5;
  color: #27272a;
  font-size: 8px;
}

.rack-overview-notes {
  margin-top: 10px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #fff;
  padding: 8px 12px;
  color: #64748b;
  font-size: 8px;
  line-height: 1.7;
}

/* Detail Mode logical relationship mapping */
.rack-group-mapping {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  overflow: hidden;
  border: 1px solid #ddd6fe;
  border-radius: 10px;
  background: linear-gradient(100deg, #fff 0%, #fafaff 72%, #f5f3ff 100%);
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.06);
}

.rack-group-mapping-main {
  min-width: 0;
  padding: 12px 14px 10px;
}

.rack-group-mapping-title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
  color: #3f3f46;
  font-size: 10px;
}

.rack-group-mapping-title strong {
  color: #4338ca;
  font-size: 12px;
}

.rack-group-mapping-title > span {
  overflow: hidden;
  color: #312e81;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rack-group-mapping-title em {
  flex: none;
  border-radius: 9999px;
  background: #ede9fe;
  padding: 2px 7px;
  color: #5b21b6;
  font-size: 8px;
  font-style: normal;
  font-weight: 800;
}

.rack-group-mapping-title > i {
  width: 1px;
  height: 12px;
  background: #ddd6fe;
}

.rack-group-mapping-title b {
  flex: none;
  color: #52525b;
  font-size: 9px;
}

.rack-group-mapping-main > p {
  margin-top: 6px;
  color: #64748b;
  font-size: 9px;
}

.rack-group-mapping-help {
  display: flex;
  align-items: center;
  gap: 9px;
  border-left: 1px solid #e9e5ff;
  background: rgba(245, 243, 255, 0.72);
  padding: 10px 13px;
  color: #6366f1;
}

.rack-group-mapping-help > i {
  flex: none;
  font-size: 16px;
}

.rack-group-mapping-help strong {
  display: block;
  color: #4338ca;
  font-size: 9px;
}

.rack-group-mapping-help p {
  margin-top: 2px;
  color: #64748b;
  font-size: 8px;
  line-height: 1.45;
}

.rack-group-mapping-legend {
  display: flex;
  grid-column: 1/-1;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px;
  border-top: 1px solid #ede9fe;
  padding: 7px 14px;
  color: #64748b;
  font-size: 8px;
}

.rack-group-mapping-legend span,
.rack-detail-relationship-legend span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.rack-group-mapping-legend b,
.rack-detail-relationship-legend b {
  display: inline-flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 8px;
}

.rack-mapping-dim-swatch {
  display: inline-block;
  width: 12px;
  height: 7px;
  border: 1px solid #d4d4d8;
  border-radius: 2px;
  background: #e4e4e7;
  opacity: 0.55;
}

.rack-detail-card.is-related {
  border-color: #a78bfa;
}

.rack-detail-card.is-selected {
  border-color: #6366f1;
  box-shadow: 0 0 0 2px #e0e7ff;
}

.rack-detail-card-header {
  min-height: 76px;
  border-bottom: 1px solid #f4f4f5;
  padding: 9px 11px 8px;
}

.rack-related-badge {
  flex: none;
  border-radius: 9999px;
  background: #ede9fe;
  padding: 2px 6px;
  color: #6d28d9;
  font-size: 7px;
  font-weight: 800;
}

.rack-detail-relation-counts {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 4px;
  margin-top: 5px;
  overflow: hidden;
  color: #64748b;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rack-detail-relation-counts strong {
  color: #4f46e5;
}

.rack-detail-relation-counts i {
  width: 1px;
  height: 9px;
  margin: 0 3px;
  background: #e4e4e7;
}

.rack-detail-role-counts {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 5px;
  color: #64748b;
  font-size: 7px;
}

.rack-detail-role-counts span {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.rack-detail-role-counts b {
  display: inline-flex;
  width: 14px;
  height: 14px;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  background: #f4f4f5;
  color: #3f3f46;
  font-size: 7px;
}

.rack-mounted-item.rack-item-dimmed {
  filter: grayscale(0.75);
  opacity: 0.28;
}

.rack-mounted-item.rack-item-dimmed:hover {
  filter: grayscale(0.5);
  opacity: 0.6;
}

.rack-mounted-item.rack-item-related-relay {
  box-shadow: inset 2px 0 #4f46e5;
}

.rack-mounted-item.rack-item-related-compute {
  box-shadow: inset 2px 0 #059669;
}

.rack-mounted-item .rack-mounted-item-name {
  min-width: 0;
  flex: 1;
}

.rack-mounted-item .rack-node-type-mark {
  display: inline-flex;
  width: 11px;
  height: 9px;
  flex: none;
  align-items: center;
  justify-content: center;
  overflow: visible;
  border-radius: 2px;
  background: #4f46e5;
  color: #fff;
  font-size: 6px;
  line-height: 1;
}

.rack-mounted-item .rack-compute-link {
  flex: none;
  color: #047857;
  font-size: 8px;
}

.rack-mounted-item .rack-relay-role-badge {
  display: inline-flex;
  width: 11px;
  height: 9px;
  flex: none;
  align-items: center;
  justify-content: center;
  overflow: visible;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.75);
  color: #4338ca;
  font-size: 6px;
  font-weight: 900;
}

.rack-detail-relationship-legend {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px 8px;
  margin-top: 11px;
  border-top: 1px solid #f4f4f5;
  padding-top: 10px;
  color: #64748b;
  font-size: 8px;
}

@media (max-width: 1399px) {
  .rack-overview-layout {
    grid-template-columns: 150px minmax(0, 1fr);
  }
  .rack-overview-layout > aside:last-child {
    display: grid;
    grid-column: 1/-1;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 1023px) {
  .rack-zone-overview-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .rack-node-type-filter {
    width: 100%;
  }
}
@media (max-width: 767px) {
  .rack-overview-layout > aside:last-child {
    grid-template-columns: minmax(0, 1fr);
  }
  .rack-node-type-filter {
    min-width: 0;
  }
}`],
})
export class PageKieraProvisioningRackComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public errorMessage: string = '';
    public mode: 'overview' | 'detail' = 'overview';

    public groupFilter: string = 'all';
    // -1 means "전체 Zone" and is the default Rack View scope.
    public zoneFilter: number = -1;
    public clusterFilter: number = 0;
    public relayFilter: number = 0;
    public nodeTypeFilter: 'all' | 'relay' | 'compute' = 'all';
    public searchText: string = '';

    public groups: any[] = [];
    public clusters: any[] = [];
    public relayOptions: any[] = [];
    public zones: any[] = [];
    public navigatorZones: any[] = [];
    public hasDefinedZones: boolean = false;
    public racks: any[] = [];
    public detailRacks: any[] = [];
    public unplaced: any[] = [];
    public summary: any = {};
    public overallSummary: any = {};
    public detailGroup: any = null;
    public updatedAt: string = '';
    public bmcCollectedAt: string = '';
    public bmcRechecking: boolean = false;
    public noticeMessage: string = '';
    public errorRackModalOpen: boolean = false;
    public errorRackModalLoading: boolean = false;
    public errorRackModalError: string = '';
    public errorRackModalRacks: any[] = [];
    public sharedRackEditorRack: any = null;

    public overviewPage: number = 1;
    public overviewPageSize: number = 20;
    public readonly navigatorPageSize: number = 20;
    public navigatorPages: { [key: string]: number } = {};
    public navigatorExpanded: { [key: string]: boolean } = {};
    public navigatorRootExpanded: boolean = true;
    public focusedNavigatorZoneId: number | null = null;
    public detailPage: number = 1;
    public detailPageSize: number = 10;
    public selectedRackId: string = '';
    public compactDetail: boolean = false;
    public zoomPercent: number = 100;
    public canvasOpen: boolean = false;
    public canvasLoading: boolean = false;
    public canvasSaving: boolean = false;
    public canvasCloseConfirming: boolean = false;
    public canvasEdit: boolean = false;
    public canvasScopeId: number = -1;
    public canvasZoomPercent: number = 75;
    public canvasPanX: number = 20;
    public canvasPanY: number = 20;
    public canvasZones: any[] = [];
    public canvasRacks: any[] = [];
    public canvasLayout: any = {
        zone_positions: {},
        rack_positions: {},
        element_styles: {},
        canvas_objects: [],
        background_image: '',
        updated: ''
    };
    public miniCanvasLayout: any = {
        zone_positions: {},
        rack_positions: {},
        element_styles: {},
        canvas_objects: [],
        background_image: '',
        updated: ''
    };
    public canvasMoves: { [key: string]: any } = {};
    public canvasChanged: boolean = false;
    public canvasMessage: string = '';
    public canvasDropShadow: any = null;
    public canvasSelection: any = null;
    public canvasTool: string = 'select';
    public readonly canvasPaintTools: any[] = [
        { value: 'select', label: '선택', icon: 'bx-pointer' },
        { value: 'rect', label: '사각형', icon: 'bx-rectangle' },
        { value: 'ellipse', label: '원형', icon: 'bx-circle' },
        { value: 'arrow', label: '화살표', icon: 'bx-right-arrow-alt' },
        { value: 'text', label: '텍스트', icon: 'bx-text' }
    ];
    public readonly canvasShapeOptions: any[] = [
        { value: 'rounded', label: '둥근 사각형', icon: 'bx-shape-square' },
        { value: 'soft', label: '완만한 사각형', icon: 'bx-square-rounded' },
        { value: 'square', label: '직사각형', icon: 'bx-square' },
        { value: 'pill', label: '캡슐형', icon: 'bx-capsule' }
    ];
    public readonly canvasColorOptions: string[] = [
        '#6366f1', '#2563eb', '#0891b2', '#059669', '#65a30d',
        '#d97706', '#dc2626', '#db2777', '#7c3aed', '#475569'
    ];
    public canvasGridSize: number = 40;
    public canvasGridEnabled: boolean = true;
    public readonly canvasGridMinSize: number = 5;
    public readonly canvasGridMaxSize: number = 200;
    public readonly canvasUnitHeight: number = 8;
    public readonly canvasZoneMinWidth: number = 420;
    public readonly canvasZoneMinHeight: number = 320;
    public readonly canvasZoneMaxSize: number = 2400;
    private searchTimer: any = null;
    private canvasOriginal: any = null;
    private canvasDrag: any = null;
    private canvasDrawing: any = null;
    private canvasObjectDrag: any = null;
    private canvasPanStart: any = null;
    private canvasDraggedItem: any = null;
    private readonly unitHeight: number = 11;
    private readonly minZoom: number = 50;
    private readonly maxZoom: number = 150;
    private readonly zoomStep: number = 10;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public ngOnDestroy() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
    }

    public async load(resetPage: boolean = false) {
        if (resetPage) {
            this.overviewPage = 1;
            this.navigatorPages = {};
            this.detailPage = 1;
        }

        this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('load', {
                group_key: this.groupFilter,
                zone_id: this.zoneFilter,
                cluster_id: this.clusterFilter,
                relay_node_id: this.relayFilter,
                node_type: this.nodeTypeFilter,
                text: this.searchText.trim()
            });

            if (code !== 200) {
                this.errorMessage = data?.message || 'Rack View 데이터를 불러오지 못했습니다.';
                return;
            }

            this.groups = data?.groups || [];
            this.groupFilter = String(
                data?.selected_group_key || this.groupFilter || 'all'
            );
            this.clusters = data?.clusters || [];
            this.relayOptions = data?.relay_options || [];
            this.zones = data?.zones || [];
            this.navigatorZones = data?.navigator_zones || this.zones;
            this.hasDefinedZones = Boolean(data?.has_defined_zones);
            this.zoneFilter = Number(data?.selected_zone_id ?? -1);
            if (
                this.focusedNavigatorZoneId !== null &&
                !this.navigatorZones.some((zone: any) => (
                    Number(zone?.id) === Number(this.focusedNavigatorZoneId)
                ))
            ) {
                this.focusedNavigatorZoneId = null;
            }
            this.racks = data?.racks || [];
            this.detailRacks = data?.detail_racks || [];
            this.unplaced = data?.unplaced || [];
            this.summary = data?.summary || {};
            this.overallSummary = data?.overall_summary || this.summary;
            this.detailGroup = data?.detail_group || null;
            this.updatedAt = data?.updated_at || '';
            this.bmcCollectedAt = data?.bmc_collected_at || '';
            this.miniCanvasLayout = this.deepClone(data?.canvas || {
                zone_positions: {},
                rack_positions: {},
                element_styles: {},
                canvas_objects: [],
                background_image: '',
                updated: ''
            });
            if (!this.miniCanvasLayout.zone_positions) this.miniCanvasLayout.zone_positions = {};
            if (!this.miniCanvasLayout.rack_positions) this.miniCanvasLayout.rack_positions = {};
            if (!this.miniCanvasLayout.element_styles) this.miniCanvasLayout.element_styles = {};
            if (!Array.isArray(this.miniCanvasLayout.canvas_objects)) this.miniCanvasLayout.canvas_objects = [];
            this.ensureCanvasObjectDefaults(this.miniCanvasLayout);
            for (const zone of this.navigatorZones) {
                const key = String(Number(zone?.id || 0));
                if (this.navigatorExpanded[key] === undefined) {
                    this.navigatorExpanded[key] = true;
                }
                this.navigatorPages[key] = Math.min(
                    this.navigatorTotalPagesFor(zone),
                    Math.max(1, Number(this.navigatorPages[key] || 1))
                );
            }

            if (this.selectedRackId && !this.detailRacks.some((rack: any) => this.rackIdentity(rack) === this.selectedRackId)) {
                this.selectedRackId = '';
            }
        } catch (error) {
            this.errorMessage = 'Rack View 데이터를 불러오는 중 오류가 발생했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public scheduleSearch() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.load(true), 350);
    }

    public async onFilterChanged() {
        await this.load(true);
    }

    public async onClusterChanged() {
        if (
            this.groupFilter !== 'all' &&
            !this.filteredGroups.some(
                (group: any) => String(group?.key || '') === this.groupFilter
            )
        ) {
            this.groupFilter = 'all';
        }
        this.relayFilter = 0;
        await this.onFilterChanged();
    }

    public async onGroupChanged() {
        if (
            this.relayFilter > 0 &&
            (
                this.relayFilterDisabled ||
                !this.filteredRelayOptions.some(
                    (relay: any) => Number(relay.id) === Number(this.relayFilter)
                )
            )
        ) {
            this.relayFilter = 0;
        }
        await this.onFilterChanged();
    }

    public async setNodeTypeFilter(nodeType: 'all' | 'relay' | 'compute') {
        if (this.nodeTypeFilter === nodeType) return;
        this.nodeTypeFilter = nodeType;
        await this.onFilterChanged();
    }

    public async switchMode(mode: 'overview' | 'detail') {
        if (mode === this.mode) return;
        this.mode = mode;
        await this.service.render();
    }

    public async selectZone(zone: any) {
        this.focusedNavigatorZoneId = null;
        this.zoneFilter = Number(zone?.id ?? -1);
        this.navigatorPages[String(this.zoneFilter)] = 1;
        this.navigatorExpanded[String(this.zoneFilter)] = true;
        await this.onFilterChanged();
    }

    public async onNavigatorZoneChanged() {
        this.focusedNavigatorZoneId = null;
        if (this.zoneFilter >= 0) {
            this.navigatorPages[String(this.zoneFilter)] = 1;
            this.navigatorExpanded[String(this.zoneFilter)] = true;
        }
        await this.onFilterChanged();
    }

    public async focusNavigatorZone(zone: any) {
        const zoneId = Number(zone?.id);
        if (!this.navigatorZones.some((item: any) => Number(item?.id) === zoneId)) return;
        this.focusedNavigatorZoneId = zoneId;
        this.overviewPage = 1;
        this.selectedRackId = '';
        await this.service.render();
    }

    public async showAllNavigatorRacks() {
        this.focusedNavigatorZoneId = null;
        this.overviewPage = 1;
        this.selectedRackId = '';
        await this.service.render();
    }

    public async openRack(rack: any) {
        this.selectedRackId = this.rackIdentity(rack);
        this.mode = 'detail';
        this.detailPage = Math.floor(
            Math.max(0, this.detailRacks.findIndex((item: any) => (
                this.rackIdentity(item) === this.selectedRackId
            ))) / this.detailPageSize
        ) + 1;

        await this.service.render();
    }

    public async openSharedRackEditor(rack: any, event?: Event) {
        event?.stopPropagation();
        if (Number(rack?.rack_record_id || 0) <= 0) return;
        this.selectedRackId = this.rackIdentity(rack);
        this.sharedRackEditorRack = { ...rack };
        await this.service.render();
    }

    public async closeSharedRackEditor() {
        this.sharedRackEditorRack = null;
        await this.service.render();
    }

    public async onSharedRackEditorSaved(result: any) {
        const rackName = result?.rack?.name
            || this.sharedRackEditorRack?.name
            || this.sharedRackEditorRack?.rack_name
            || 'Rack';
        this.sharedRackEditorRack = null;
        await this.service.render();
        await this.load(false);
        this.noticeMessage = `${rackName}을(를) 수정했습니다.`;
        await this.service.render();
    }

    public async openErrorRackModal() {
        if (this.errorRackModalLoading) return;
        this.errorRackModalOpen = true;
        this.errorRackModalLoading = true;
        this.errorRackModalError = '';
        this.errorRackModalRacks = [];
        await this.service.render();

        try {
            const { code, data } = await wiz.call('load', {
                group_key: this.groupFilter,
                zone_id: this.zoneFilter,
                cluster_id: this.clusterFilter,
                text: ''
            });
            if (code !== 200) {
                this.errorRackModalError = data?.message || '배포 실패 Rack 목록을 불러오지 못했습니다.';
                return;
            }
            this.errorRackModalRacks = (data?.detail_racks || []).filter(
                (rack: any) => rack?.status === 'failed'
            );
        } catch (error) {
            this.errorRackModalError = '배포 실패 Rack 목록을 불러오는 중 오류가 발생했습니다.';
        } finally {
            this.errorRackModalLoading = false;
            await this.service.render();
        }
    }

    public async closeErrorRackModal() {
        this.errorRackModalOpen = false;
        await this.service.render();
    }

    public async openErrorRackDetail(rack: any) {
        this.errorRackModalOpen = false;
        if (this.searchText.trim()) {
            this.searchText = '';
            await this.load(true);
        }
        const targetRack = this.detailRacks.find((item: any) => (
            this.rackIdentity(item) === this.rackIdentity(rack)
        ));
        if (targetRack) {
            await this.openRack(targetRack);
            return;
        }
        await this.service.render();
    }

    public async openNavigatorRack(zone: any, rack: any) {
        const rackIdentity = this.rackIdentity(rack);
        let targetRack = this.detailRacks.find((item: any) => (
            this.rackIdentity(item) === rackIdentity
        ));

        if (!targetRack) {
            this.zoneFilter = Number(zone?.id ?? -1);
            this.clusterFilter = 0;
            this.searchText = '';
            await this.load(true);
            targetRack = this.detailRacks.find((item: any) => (
                this.rackIdentity(item) === rackIdentity
            ));
        }
        if (targetRack) await this.openRack(targetRack);
    }

    public openRackEditor() {
        this.service.href('/kiera/zones');
    }

    public get zoomScale(): number {
        return this.zoomPercent / 100;
    }

    public get zoomSurfaceWidth(): number {
        return 100 / this.zoomScale;
    }

    public async zoomOut() {
        await this.setZoom(this.zoomPercent - this.zoomStep);
    }

    public async zoomIn() {
        await this.setZoom(this.zoomPercent + this.zoomStep);
    }

    public async fitView() {
        const selector = this.mode === 'detail'
            ? '.rack-detail-viewport'
            : '.rack-overview-viewport';
        const viewport = document.querySelector(selector) as HTMLElement | null;
        const racks = this.mode === 'detail' ? this.visibleDetailRacks : this.overviewRacks;

        if (!viewport || racks.length === 0) {
            await this.setZoom(100);
            return;
        }

        const maxColumns = this.mode === 'detail' ? 4 : 6;
        const cardWidth = this.mode === 'detail' ? 230 : 210;
        const gap = this.mode === 'detail' ? 10 : 12;
        const columns = Math.max(1, Math.min(maxColumns, racks.length));
        const naturalWidth = columns * cardWidth + Math.max(0, columns - 1) * gap + 32;
        const availableWidth = Math.max(1, viewport.clientWidth - 32);
        const fitted = Math.floor((availableWidth / naturalWidth) * 100 / 5) * 5;

        await this.setZoom(Math.min(100, fitted));
    }

    private async setZoom(percent: number) {
        this.zoomPercent = Math.max(
            this.minZoom,
            Math.min(this.maxZoom, Math.round(percent))
        );
        await this.service.render();
    }

    public openNode(item: any) {
        const itemId = Number(item?.id || 0);
        if (itemId <= 0) return;
        if (item?.item_type === 'chassis') {
            this.service.href(`/kiera/chassis/${itemId}/summary`);
            return;
        }
        if (item?.item_type !== 'node') return;
        this.service.href(`/kiera/nodes/${itemId}/summary`);
    }

    public async refresh() {
        await this.load(false);
    }

    public get filteredClusters(): any[] {
        return this.clusters;
    }

    public get filteredGroups(): any[] {
        if (!this.clusterFilter) return this.groups;
        return this.groups.filter(
            (group: any) => (group?.cluster_ids || [])
                .map(Number)
                .includes(Number(this.clusterFilter))
        );
    }

    public get filteredRelayOptions(): any[] {
        return this.relayOptions.filter((relay: any) => {
            const clusterMatches = !this.clusterFilter || (
                relay?.cluster_ids || []
            ).map(Number).includes(Number(this.clusterFilter));
            const groupMatches = this.groupFilter === 'all' || (
                relay?.group_keys || []
            ).map(String).includes(this.groupFilter);
            return clusterMatches && groupMatches;
        });
    }

    public get selectedRelay(): any {
        return this.relayOptions.find(
            (relay: any) => Number(relay?.id) === Number(this.relayFilter)
        ) || null;
    }

    public get zoneOverviewCards(): any[] {
        const overall = this.overallSummary || this.summary;
        const allZones = {
            id: -1,
            name: 'All Zones',
            rack_count: Number(overall?.rack_count || 0),
            deployment_node_count: Number(overall?.deployment_node_count || 0),
            deployed_node_count: Number(overall?.deployed_node_count || 0),
            deploying_node_count: Number(overall?.deploying_node_count || 0),
            ready_node_count: Number(overall?.ready_node_count || 0),
            waiting_node_count: Number(overall?.waiting_node_count || 0),
            failed_node_count: Number(overall?.failed_node_count || 0),
            relay_node_count: Number(overall?.relay_node_count || 0),
            compute_node_count: Number(overall?.compute_node_count || 0),
        };
        return [allZones, ...this.zones];
    }

    public isZoneOverviewActive(zone: any): boolean {
        return this.focusedNavigatorZoneId === null && (
            Number(zone?.id) === Number(this.zoneFilter)
        );
    }

    public statusPercent(count: any, total: any): number {
        const denominator = Number(total || 0);
        if (denominator <= 0) return 0;
        return Math.round(Math.max(0, Number(count || 0)) / denominator * 1000) / 10;
    }

    public zoneStatusPercent(zone: any, count: any): number {
        return this.statusPercent(count, zone?.deployment_node_count);
    }

    public get nodeTypeSummaryRows(): any[] {
        const states = ['deployed', 'deploying', 'ready', 'waiting', 'failed'];
        const makeRow = (
            key: string,
            label: string,
            prefix: string,
            totalKey: string,
        ) => {
            const row: any = { key, label };
            row.total = Number(this.summary?.[totalKey] || 0);
            for (const state of states) {
                row[state] = Number(
                    this.summary?.[`${prefix}${state}_node_count`] || 0
                );
            }
            return row;
        };
        return [
            makeRow('all', '전체', '', 'deployment_node_count'),
            makeRow('relay', 'Relay', 'relay_', 'relay_node_count'),
            makeRow('compute', 'Compute', 'compute_', 'compute_node_count'),
        ];
    }

    public rackRelationshipLabel(rack: any): string {
        const relayNames = (rack?.relay_names || [])
            .map((value: any) => String(value || '').trim())
            .filter((value: string) => Boolean(value));
        const groupNames = (rack?.group_names || [rack?.group_name])
            .map((value: any) => String(value || '').trim())
            .filter((value: string) => Boolean(value));
        const labels = [
            ...relayNames.slice(0, 1).map((name: string) => `${name} [Relay]`),
            ...groupNames.slice(0, 2).map((name: string) => `${name} [General]`),
        ];
        return labels.length > 0 ? labels.join(' · ') : '미할당';
    }

    public get selectedZone(): any {
        if (Number(this.zoneFilter) < 0) return null;
        return this.navigatorZones.find(
            (zone: any) => Number(zone.id) === Number(this.zoneFilter)
        ) || null;
    }

    public get focusedNavigatorZone(): any {
        if (this.focusedNavigatorZoneId === null) return null;
        return this.navigatorZones.find(
            (zone: any) => Number(zone?.id) === Number(this.focusedNavigatorZoneId)
        ) || null;
    }

    public get overviewSelectedZone(): any {
        return this.focusedNavigatorZone || this.selectedZone;
    }

    public get isNavigatorRootActive(): boolean {
        return this.focusedNavigatorZoneId === null && Number(this.zoneFilter) === -1;
    }

    public isNavigatorZoneActive(zone: any): boolean {
        const activeZoneId = this.focusedNavigatorZoneId !== null
            ? Number(this.focusedNavigatorZoneId)
            : (Number(this.zoneFilter) >= 0 ? Number(this.zoneFilter) : null);
        return activeZoneId !== null && activeZoneId === Number(zone?.id);
    }

    public get navigatorRackCount(): number {
        return this.visibleNavigatorZones.reduce(
            (total: number, zone: any) => total + this.navigatorRacks(zone).length,
            0
        );
    }

    public get visibleNavigatorZones(): any[] {
        if (Number(this.zoneFilter) === -1) return this.navigatorZones;
        return this.selectedZone ? [this.selectedZone] : [];
    }

    public get hasUnassignedZone(): boolean {
        return this.navigatorZones.some((zone: any) => Number(zone?.id) === 0);
    }

    public get overviewSourceRacks(): any[] {
        if (!this.focusedNavigatorZone) return this.racks;
        const zoneId = Number(this.focusedNavigatorZone?.id || 0);
        return this.racks.filter(
            (rack: any) => Number(rack?.zone_id || 0) === zoneId
        );
    }

    public get overviewRackCount(): number {
        return this.overviewSourceRacks.length;
    }

    public get showOverviewZoneGroups(): boolean {
        return Number(this.zoneFilter) === -1 && this.focusedNavigatorZoneId === null;
    }

    public get overviewTotalPages(): number {
        return Math.max(1, Math.ceil(this.overviewRackCount / this.overviewPageSize));
    }

    public navigatorPageFor(zone: any): number {
        return Math.max(1, Number(this.navigatorPages[String(Number(zone?.id || 0))] || 1));
    }

    public navigatorTotalPagesFor(zone: any): number {
        return Math.max(1, Math.ceil(this.navigatorRacks(zone).length / this.navigatorPageSize));
    }

    public navigatorPagedRacks(zone: any): any[] {
        const start = (this.navigatorPageFor(zone) - 1) * this.navigatorPageSize;
        return this.navigatorRacks(zone).slice(start, start + this.navigatorPageSize);
    }

    public get detailTotalPages(): number {
        return Math.max(1, Math.ceil(this.detailRacks.length / this.detailPageSize));
    }

    public get overviewRacks(): any[] {
        const start = (this.overviewPage - 1) * this.overviewPageSize;
        return this.overviewSourceRacks.slice(start, start + this.overviewPageSize);
    }

    public get overviewZoneGroups(): any[] {
        const visibleRacks = this.overviewRacks;
        return this.navigatorZones.map((zone: any) => {
            const zoneId = Number(zone?.id || 0);
            return {
                zone,
                total: this.navigatorRacks(zone).length,
                racks: visibleRacks.filter(
                    (rack: any) => Number(rack?.zone_id || 0) === zoneId
                )
            };
        });
    }

    public get visibleDetailRacks(): any[] {
        const start = (this.detailPage - 1) * this.detailPageSize;
        return this.detailRacks.slice(start, start + this.detailPageSize);
    }

    public setOverviewPage(page: number) {
        this.overviewPage = Math.min(this.overviewTotalPages, Math.max(1, page));
        this.service.render();
    }

    public setNavigatorZonePage(zone: any, page: number) {
        const key = String(Number(zone?.id || 0));
        this.navigatorPages[key] = Math.min(
            this.navigatorTotalPagesFor(zone),
            Math.max(1, page)
        );
        this.service.render();
    }

    public isNavigatorExpanded(zone: any): boolean {
        return this.navigatorExpanded[String(Number(zone?.id || 0))] !== false;
    }

    public toggleNavigatorZone(zone: any) {
        const key = String(Number(zone?.id || 0));
        this.navigatorExpanded[key] = !this.isNavigatorExpanded(zone);
        this.service.render();
    }

    public toggleNavigatorRoot() {
        this.navigatorRootExpanded = !this.navigatorRootExpanded;
        this.service.render();
    }

    public setDetailPage(page: number) {
        this.detailPage = Math.min(this.detailTotalPages, Math.max(1, page));
        this.service.render();
    }

    public navigatorRacks(zone: any): any[] {
        return this.zoneRacks(zone);
    }

    public zoneMapRacks(zone: any): any[] {
        return this.zoneRacks(zone).slice(0, 40);
    }

    private zoneRacks(zone: any): any[] {
        if (Array.isArray(zone?.rack_states)) return zone.rack_states;
        return this.racks.filter(
            (rack: any) => Number(rack.zone_id || 0) === Number(zone?.id)
        );
    }

    public zoneLocationLabel(zone: any): string {
        return String(zone?.location || '').trim() || '위치 미지정';
    }

    public zoneNavigatorLabel(zone: any): string {
        const name = String(zone?.name || 'Zone');
        const location = String(zone?.location || '').trim();
        return location ? `${location} (${name})` : name;
    }

    public zoneOptionLabel(zone: any): string {
        const range = String(zone?.rack_range || '').trim();
        return [zone?.name, this.zoneLocationLabel(zone), range && range !== '-' ? range : '']
            .filter((value: any) => String(value || '').trim())
            .join(' · ');
    }

    public get normalRackCount(): number {
        const total = Number(this.summary?.rack_count || 0);
        const errors = Number(this.summary?.error_rack_count || 0);
        const empty = Number(this.summary?.empty_rack_count || 0);
        return Math.max(0, total - errors - empty);
    }

    public rackStatusPercent(count: any): number {
        const total = Number(this.summary?.rack_count || 0);
        if (total <= 0) return 0;
        return Math.round(Math.max(0, Number(count || 0)) / total * 1000) / 10;
    }

    public deploymentStatusPercent(count: any): number {
        const total = Number(this.summary?.deployment_node_count || 0);
        if (total <= 0) return 0;
        return Math.round(Math.max(0, Number(count || 0)) / total * 1000) / 10;
    }

    public get selectedCluster(): any {
        return this.clusters.find(
            (cluster: any) => Number(cluster?.id || 0) === Number(this.clusterFilter)
        ) || null;
    }

    public get selectedGroup(): any {
        return this.groups.find(
            (group: any) => String(group?.key || '') === this.groupFilter
        ) || null;
    }

    public get isRelayGroupSelected(): boolean {
        return String(this.selectedGroup?.kind || '') === 'relay';
    }

    public get relayFilterDisabled(): boolean {
        return String(this.selectedGroup?.kind || '') === 'general';
    }

    public get detailRelatedRackLabel(): string {
        const related = Number(
            this.detailGroup?.related_rack_count ?? this.detailRacks.length
        );
        const total = Number(
            this.detailGroup?.total_rack_count ?? related
        );
        return '관련 Rack ' + related + '개 / 전체 Rack ' + total + '개';
    }

    public get detailMappingDescription(): string {
        if (this.detailGroup?.kind === 'relay') {
            const relay = String(
                this.detailGroup?.selected_relay_name || ''
            ).trim();
            return relay
                ? relay + '와 해당 Relay가 담당하는 Compute의 물리 위치입니다.'
                : '선택 Relay Group의 Relay와 담당 Compute를 실제 U 위치에서 강조합니다.';
        }
        if (this.detailGroup?.kind === 'general') {
            return '선택한 일반 Group 소속 노드를 실제 U 위치에서 강조합니다.';
        }
        return '필터 조건에 해당하는 노드를 실제 U 위치에서 강조합니다.';
    }

    public relayRoleBadge(item: any): string {
        const role = String(item?.relay_role || '').toLowerCase();
        if (role === 'authority') return 'A';
        if (role === 'member') return 'M';
        return '';
    }

    public itemRelationshipTitle(item: any): string {
        const unitStart = Number(item?.unit_start || 0);
        const unitEnd = Number(item?.unit_end || 0);
        const unitLabel = 'U' + unitStart + (
            unitEnd !== unitStart ? '-U' + unitEnd : ''
        );
        const labels = [
            String(item?.name || '').trim(),
            unitLabel,
            String(item?.group_name || '').trim(),
        ];
        if (item?.node_type === 'relay') {
            labels.push(
                'Relay · ' + String(item?.relay_role || 'member')
            );
        } else if (item?.node_type === 'compute' && item?.relay_name) {
            labels.push('담당 Relay: ' + item.relay_name);
        }
        return labels.filter((value: string) => Boolean(value)).join(' · ');
    }

    public get deploymentJobTitle(): string {
        const clusterName = String(this.selectedCluster?.name || '').trim();
        if (clusterName) return clusterName + ' 배포 현황';
        const groupName = String(this.selectedGroup?.name || '').trim();
        if (groupName) return groupName + ' 배포 현황';
        return '전체 클러스터 배포 현황';
    }

    public get deploymentScopeLabel(): string {
        const labels = [
            String(this.selectedCluster?.name || '').trim(),
            String(this.selectedGroup?.name || '').trim(),
            String(this.selectedRelay?.name || '').trim(),
            this.nodeTypeFilter === 'all'
                ? ''
                : (this.nodeTypeFilter === 'relay' ? 'Relay 노드' : 'Compute 노드'),
        ].filter((value: string) => Boolean(value));
        return labels.length > 0 ? labels.join(' · ') : '전체 클러스터 · 전체 그룹';
    }

    public get deploymentProgressPercent(): number {
        return this.deploymentStatusPercent(this.summary?.deployed_node_count);
    }

    public get deploymentJobStatusLabel(): string {
        if (Number(this.summary?.deploying_node_count || 0) > 0) return 'Running';
        if (Number(this.summary?.failed_node_count || 0) > 0) return 'Failed';
        const total = Number(this.summary?.deployment_node_count || 0);
        if (total > 0 && Number(this.summary?.deployed_node_count || 0) >= total) return 'Completed';
        if (Number(this.summary?.ready_node_count || 0) > 0) return 'Ready';
        return 'New';
    }

    public get deploymentJobStatusClass(): string {
        const status = this.deploymentJobStatusLabel;
        if (status === 'Failed') return 'is-failed';
        if (status === 'Running') return 'is-running';
        if (status === 'Completed') return 'is-completed';
        if (status === 'Ready') return 'is-ready';
        return 'is-new';
    }

    public openDeploymentJobDetail() {
        const clusterId = Number(this.selectedCluster?.id || 0);
        this.service.href(
            clusterId > 0
                ? '/kiera/cluster-deploy/' + clusterId + '/overview'
                : '/kiera/cluster-deploy'
        );
    }

    public trackStatusSegment(index: number, segment: any): string {
        return String(segment?.key || `segment:${index}`);
    }

    public rackUnitStateClass(state: any): string {
        if (state === 'deployed') return 'bg-green-600';
        if (state === 'ready') return 'bg-cyan-500';
        if (state === 'deploying') return 'bg-blue-600';
        if (state === 'failed') return 'bg-red-500';
        if (state === 'waiting') return 'bg-slate-400';
        if (state === 'not_applicable') return 'bg-zinc-300';
        return 'bg-zinc-200';
    }

    public rackUnitStateLabel(state: any): string {
        if (state === 'deployed') return '배포 완료';
        if (state === 'ready') return '배포 준비';
        if (state === 'deploying') return '배포 중';
        if (state === 'failed') return '배포 실패';
        if (state === 'waiting') return '신규';
        if (state === 'not_applicable') return '배포 대상 아님';
        return '비어 있음';
    }

    public rackStatusSegmentLabel(segment: any): string {
        const unitStart = Math.max(1, Number(segment?.unit_start || 1));
        const unitEnd = Math.max(unitStart, Number(segment?.unit_end || unitStart));
        const unitLabel = unitEnd > unitStart
            ? `U${unitStart}–U${unitEnd}`
            : `U${unitStart}`;
        const labels = [unitLabel];
        const itemName = String(segment?.item_name || '').trim();
        if (itemName) labels.push(itemName);
        labels.push(this.rackUnitStateLabel(segment?.status));
        const counts = segment?.deployment_counts || {};
        const chassisSummary = [
            ['완료', counts.deployed],
            ['배포 중', counts.deploying],
            ['준비', counts.ready],
            ['신규', counts.waiting],
            ['실패', counts.failed],
        ]
            .filter((entry: any[]) => Number(entry[1] || 0) > 0)
            .map((entry: any[]) => `${entry[0]} ${entry[1]}`)
            .join(', ');
        if (chassisSummary) labels.push(chassisSummary);
        return labels.join(' · ');
    }

    public rackUnitSummaryLabel(rack: any): string {
        const failed = Number(rack?.failed_node_count || 0);
        if (failed > 0) return `배포 실패 ${failed}개`;
        const deploying = Number(rack?.deploying_node_count || 0);
        if (deploying > 0) return `배포 중 ${deploying}개`;
        const waiting = Number(rack?.waiting_node_count || 0);
        if (waiting > 0) return `신규 ${waiting}개`;
        const ready = Number(rack?.ready_node_count || 0);
        if (ready > 0) return `배포 준비 ${ready}개`;
        const deployed = Number(rack?.deployed_node_count || 0);
        if (deployed > 0) return `배포 완료 ${deployed}개`;
        return '배포 대상 없음';
    }

    public rackStatusSummaryClass(rack: any): string {
        const status = String(rack?.status || '');
        if (status === 'failed') return 'font-semibold text-red-600';
        if (status === 'deploying') return 'font-semibold text-blue-600';
        if (status === 'ready') return 'font-semibold text-cyan-600';
        if (status === 'deployed') return 'font-semibold text-green-600';
        return 'text-slate-500';
    }

    public rackStateLabel(rack: any): string {
        return this.rackUnitStateLabel(rack?.status);
    }

    public rackStateClass(rack: any): string {
        return this.rackUnitStateClass(rack?.status);
    }

    public zoneStateClass(zone: any): string {
        if (Number(zone?.failed_rack_count || 0) > 0) return 'bg-red-500';
        if (Number(zone?.deploying_rack_count || 0) > 0) return 'bg-blue-600';
        if (Number(zone?.waiting_rack_count || 0) > 0) return 'bg-slate-400';
        if (Number(zone?.ready_rack_count || 0) > 0) return 'bg-cyan-500';
        if (Number(zone?.deployed_rack_count || 0) > 0) return 'bg-green-600';
        return 'bg-zinc-300';
    }

    public rackDisplayName(rack: any): string {
        const rackName = String(rack?.name || 'Rack');
        if (this.groupFilter !== 'all') return rackName;

        const groupName = String(rack?.group_name || '그룹 미지정');
        return `[${groupName}] - ${rackName}`;
    }

    public rackNavigatorName(rack: any): string {
        return String(rack?.name || 'Rack');
    }

    public placedItems(rack: any): any[] {
        const capacity = this.rackCapacity(rack);
        return (rack?.items || []).filter((item: any) => (
            Number(item.unit_start) > 0 &&
            Number(item.unit_start) <= capacity &&
            !item.layout_overflow
        ));
    }

    public rackCapacity(rack: any): number {
        return Math.max(1, Number(rack?.capacity_u || rack?.rack_size_u || 42));
    }

    public rackUnitsFor(rack: any): number[] {
        const capacity = this.rackCapacity(rack);
        return Array.from({ length: capacity }, (_, index) => capacity - index);
    }

    public rackItemBottom(item: any): number {
        return (Math.max(1, Number(item?.unit_start || 1)) - 1) * this.unitHeight;
    }

    public rackItemHeight(item: any): number {
        const size = Math.max(1, Math.min(100, Number(item?.unit_size || 1)));
        return Math.max(this.unitHeight - 1, size * this.unitHeight - 1);
    }

    public rackBodyHeight(rack: any): number {
        return this.rackCapacity(rack) * this.unitHeight;
    }

    public itemClass(item: any): string {
        const state = String(item?.deployment_state?.key || 'waiting');
        let stateClass = 'rack-device-waiting';
        if (state === 'deployed') stateClass = 'rack-device-deployed';
        if (state === 'ready') stateClass = 'rack-device-ready';
        if (state === 'deploying') stateClass = 'rack-device-deploying';
        if (state === 'failed') stateClass = 'rack-device-deploy-failed';
        if (state === 'not_applicable') stateClass = 'rack-device-not-applicable';

        const relationshipClasses: string[] = [];
        if (item?.relationship_context_active) {
            if (item?.is_dimmed) relationshipClasses.push('rack-item-dimmed');
            if (item?.is_highlighted) relationshipClasses.push('rack-item-related');
            if (item?.is_highlighted && item?.node_type === 'relay') {
                relationshipClasses.push('rack-item-related-relay');
            }
            if (item?.is_highlighted && item?.node_type === 'compute') {
                relationshipClasses.push('rack-item-related-compute');
            }
        }
        return [stateClass, ...relationshipClasses].join(' ');
    }

    public itemIcon(item: any): string {
        if (item?.item_type === 'node') return 'bx bx-server';
        if (item?.item_type === 'chassis') return 'bx bx-cabinet';
        const type = String(item?.device_type || '');
        if (type === 'storage') return 'bx bx-data';
        if (type === 'pdu') return 'bx bx-plug';
        if (type === 'firewall') return 'bx bx-shield-quarter';
        return 'bx bx-network-chart';
    }

    public chassisMonitorTitle(item: any): string {
        const name = String(item?.name || 'Chassis');
        const nodeCount = Math.max(0, Number(item?.node_count || 0));
        const slotCount = Math.max(0, Number(item?.slot_count || 0));
        const slots = Array.isArray(item?.slots) ? item.slots : [];
        const slotSummary = slots.map(
            (slot: any) => this.chassisSlotTitle(slot),
        ).join(' · ');
        return [name, `${nodeCount}/${slotCount} Nodes`, slotSummary]
            .filter((value: string) => Boolean(value))
            .join(' · ');
    }

    public chassisSlotTitle(slot: any): string {
        const slotName = `S${Math.max(1, Number(slot?.index || 1))}`;
        const nodeName = String(slot?.node_name || '').trim();
        const state = String(slot?.status || 'empty').toLowerCase();
        if (state === 'empty' || !nodeName) return `${slotName} · 빈 슬롯`;
        return `${slotName} · ${nodeName} · ${this.rackUnitStateLabel(state)}`;
    }

    public trackChassisSlot(index: number, slot: any): number {
        return Number(slot?.index || index + 1);
    }

    public miniRackClass(rack: any): string {
        if (this.rackIdentity(rack) === this.selectedRackId) return 'ring-2 ring-indigo-500 bg-indigo-50';
        const status = String(rack?.status || '');
        if (status === 'failed') return 'border-red-200 bg-red-50';
        if (status === 'deploying') return 'border-blue-200 bg-blue-50';
        if (status === 'ready') return 'border-cyan-200 bg-cyan-50';
        if (status === 'deployed') return 'border-green-200 bg-green-50';
        return 'border-zinc-200 bg-zinc-50';
    }

    public miniMapZoneRacks(zone: any): any[] {
        return Array.isArray(zone?.rack_states) ? zone.rack_states : [];
    }

    public miniCanvasObjects(scopeId: number): any[] {
        const objects = Array.isArray(this.miniCanvasLayout?.canvas_objects)
            ? this.miniCanvasLayout.canvas_objects
            : [];
        return objects.filter(
            (object: any) => Number(object?.scope_id ?? -1) === Number(scopeId)
        );
    }

    public miniMapZonePosition(zone: any): any {
        const zoneId = String(Number(zone?.id || 0));
        const saved = this.miniCanvasLayout?.zone_positions?.[zoneId];
        if (saved) {
            return {
                x: Number(saved.x || 0),
                y: Number(saved.y || 0),
                width: Math.max(420, Number(saved.width || 760)),
                height: Math.max(320, Number(saved.height || 560))
            };
        }
        const zoneIndex = Math.max(0, this.navigatorZones.findIndex(
            (item: any) => Number(item?.id || 0) === Number(zone?.id || 0)
        ));
        const rows = Math.max(1, Math.ceil(this.miniMapZoneRacks(zone).length / 3));
        return {
            x: 60 + (zoneIndex % 2) * 820,
            y: 60 + Math.floor(zoneIndex / 2) * 1550,
            width: 760,
            height: Math.max(560, 105 + rows * 440)
        };
    }

    public miniMapRackPosition(rack: any, zone?: any): any {
        const rackId = String(Number(rack?.rack_record_id || 0));
        const saved = this.miniCanvasLayout?.rack_positions?.[rackId];
        if (saved) {
            return {
                x: Number(saved.x || 0),
                y: Number(saved.y || 0)
            };
        }
        const targetZone = zone || this.navigatorZones.find(
            (item: any) => Number(item?.id || 0) === Number(rack?.zone_id || 0)
        );
        const zoneRacks = targetZone
            ? this.miniMapZoneRacks(targetZone)
            : this.detailRacks;
        const rackIndex = Math.max(0, zoneRacks.findIndex(
            (item: any) => Number(item?.rack_record_id || 0) === Number(rack?.rack_record_id || 0)
        ));
        return {
            x: 34 + (rackIndex % 3) * 230,
            y: 78 + Math.floor(rackIndex / 3) * 440
        };
    }

    public get miniMapOverallContentWidth(): number {
        return Math.max(1600, ...this.navigatorZones.map((zone: any) => {
            const position = this.miniMapZonePosition(zone);
            return Number(position.x) + Number(position.width) + 100;
        }), ...this.miniCanvasObjects(-1).map((object: any) => (
            this.canvasObjectOuterEdge(object, 'x') + 100
        )));
    }

    public get miniMapOverallContentHeight(): number {
        return Math.max(1000, ...this.navigatorZones.map((zone: any) => {
            const position = this.miniMapZonePosition(zone);
            return Number(position.y) + Number(position.height) + 100;
        }), ...this.miniCanvasObjects(-1).map((object: any) => (
            this.canvasObjectOuterEdge(object, 'y') + 100
        )));
    }

    public get miniMapDetailContentWidth(): number {
        return Math.max(
            1500,
            ...this.detailRacks.map((rack: any) => (
                Number(this.miniMapRackPosition(rack).x) + 220
            )),
            ...this.miniCanvasObjects(this.zoneFilter).map((object: any) => (
                this.canvasObjectOuterEdge(object, 'x')
            ))
        ) + 100;
    }

    public get miniMapDetailContentHeight(): number {
        return Math.max(
            900,
            ...this.detailRacks.map((rack: any) => (
                Number(this.miniMapRackPosition(rack).y)
                + this.canvasRackBodyHeight(rack)
                + 100
            )),
            ...this.miniCanvasObjects(this.zoneFilter).map((object: any) => (
                this.canvasObjectOuterEdge(object, 'y')
            ))
        ) + 100;
    }

    private miniMapScale(width: number, height: number): number {
        return Math.min(1, Math.min(208 / Math.max(1, width), 142 / Math.max(1, height)));
    }

    public get miniMapOverallScale(): number {
        return this.miniMapScale(
            this.miniMapOverallContentWidth,
            this.miniMapOverallContentHeight
        );
    }

    public get miniMapDetailScale(): number {
        return this.miniMapScale(
            this.miniMapDetailContentWidth,
            this.miniMapDetailContentHeight
        );
    }

    public miniMapOffsetX(width: number, scale: number): number {
        return Math.max(4, (216 - width * scale) / 2);
    }

    public miniMapOffsetY(height: number, scale: number): number {
        return Math.max(4, (150 - height * scale) / 2);
    }

    public get miniCanvasBackgroundStyle(): string {
        const filename = String(this.miniCanvasLayout?.background_image || '');
        const grid = 'radial-gradient(circle, rgba(100,116,139,.22) 1px, transparent 1px)';
        if (!filename) return grid;
        const url = `/wiz/api/page.kiera.rack/canvas_background?action=view&v=${encodeURIComponent(filename)}`;
        return `linear-gradient(rgba(248,250,252,.78), rgba(248,250,252,.78)), url("${url}"), ${grid}`;
    }

    public async openSpatialCanvas(scopeId: number = -1) {
        this.canvasOpen = true;
        this.canvasMessage = '';
        await this.service.render();
        await this.loadCanvasScope(Number(scopeId));
        setTimeout(() => {
            const overlay = document.querySelector('.rack-spatial-overlay') as HTMLElement | null;
            if (overlay) overlay.focus();
        }, 0);
    }

    public async closeSpatialCanvas() {
        if (this.canvasSaving || this.canvasCloseConfirming) return;
        if (this.canvasEdit && this.canvasChanged) {
            this.canvasCloseConfirming = true;
            await this.service.render();
            let shouldSave = false;
            try {
                shouldSave = await this.service.modal.show({
                    title: '저장하지 않은 캔버스 변경사항',
                    message: 'Edit Mode에서 변경한 내용이 있습니다. 저장하시겠습니까? 저장하지 않으면 변경사항을 버리고 닫습니다.',
                    action: '저장 후 닫기',
                    cancel: '저장 안 함',
                    status: 'warning',
                    actionBtn: 'success',
                });
            } finally {
                this.canvasCloseConfirming = false;
            }
            if (shouldSave) {
                await this.saveCanvasEdit();
                if (this.canvasEdit) return;
            } else {
                this.discardCanvasEdit();
            }
        }
        this.canvasOpen = false;
        this.canvasEdit = false;
        this.canvasChanged = false;
        this.canvasCloseConfirming = false;
        this.canvasOriginal = null;
        this.canvasDrag = null;
        this.canvasDrawing = null;
        this.canvasObjectDrag = null;
        this.canvasPanStart = null;
        this.canvasDraggedItem = null;
        this.canvasDropShadow = null;
        this.canvasSelection = null;
        this.canvasTool = 'select';
        this.canvasMessage = '';
        await this.service.render();
    }

    public async onCanvasScopeChanged() {
        if (this.canvasEdit) return;
        await this.loadCanvasScope(Number(this.canvasScopeId));
    }

    private async loadCanvasScope(scopeId: number) {
        this.canvasLoading = true;
        this.canvasMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('load', {
                group_id: 0,
                zone_id: scopeId,
                cluster_id: 0,
                text: ''
            });
            if (code !== 200) {
                this.canvasMessage = data?.message || 'Rack 배치 캔버스를 불러오지 못했습니다.';
                return;
            }
            this.canvasScopeId = Number(data?.selected_zone_id ?? scopeId);
            this.canvasZones = this.deepClone(data?.navigator_zones || []);
            this.canvasRacks = this.deepClone(data?.detail_racks || []);
            this.canvasLayout = this.deepClone(data?.canvas || {
                zone_positions: {},
                rack_positions: {},
                element_styles: {},
                canvas_objects: [],
                background_image: '',
                updated: ''
            });
            if (!this.canvasLayout.zone_positions) this.canvasLayout.zone_positions = {};
            if (!this.canvasLayout.rack_positions) this.canvasLayout.rack_positions = {};
            if (!this.canvasLayout.element_styles) this.canvasLayout.element_styles = {};
            if (!Array.isArray(this.canvasLayout.canvas_objects)) this.canvasLayout.canvas_objects = [];
            this.ensureCanvasObjectDefaults();
            this.ensureCanvasDefaults();
            this.canvasMoves = {};
            this.canvasChanged = false;
            this.canvasEdit = false;
            this.canvasDropShadow = null;
            this.canvasSelection = null;
            this.canvasDrawing = null;
            this.canvasObjectDrag = null;
            this.canvasTool = 'select';
            this.canvasOriginal = this.canvasSnapshot();
            await this.fitCanvas();
        } catch (error) {
            this.canvasMessage = 'Rack 배치 캔버스를 불러오는 중 오류가 발생했습니다.';
        } finally {
            this.canvasLoading = false;
            await this.service.render();
        }
    }

    private deepClone<T>(value: T): T {
        return JSON.parse(JSON.stringify(value ?? null));
    }

    private canvasSnapshot(): any {
        return this.deepClone({
            layout: this.canvasLayout,
            racks: this.canvasRacks,
            moves: this.canvasMoves
        });
    }

    private ensureCanvasDefaults() {
        const zonePositions = this.canvasLayout.zone_positions;
        const rackPositions = this.canvasLayout.rack_positions;
        this.canvasZones.forEach((zone: any, zoneIndex: number) => {
            const zoneId = String(Number(zone?.id || 0));
            const zoneRacks = this.canvasRacksForZone(zone);
            const rows = Math.max(1, Math.ceil(zoneRacks.length / 3));
            const defaultWidth = 760;
            const defaultHeight = Math.max(560, 105 + rows * 440);
            const current = zonePositions[zoneId] || {};
            const currentWidth = Number(current.width);
            const currentHeight = Number(current.height);
            zonePositions[zoneId] = {
                x: Number.isFinite(Number(current.x)) ? Number(current.x) : 60 + (zoneIndex % 2) * 820,
                y: Number.isFinite(Number(current.y)) ? Number(current.y) : 60 + Math.floor(zoneIndex / 2) * 1550,
                width: Math.round(Math.min(
                    this.canvasZoneMaxSize,
                    Math.max(
                        this.canvasZoneMinWidth,
                        Number.isFinite(currentWidth) ? currentWidth : defaultWidth
                    )
                )),
                height: Math.round(Math.min(
                    this.canvasZoneMaxSize,
                    Math.max(
                        this.canvasZoneMinHeight,
                        Number.isFinite(currentHeight) ? currentHeight : defaultHeight
                    )
                ))
            };
            zoneRacks.forEach((rack: any, rackIndex: number) => {
                const rackId = String(Number(rack?.rack_record_id || 0));
                if (!rackPositions[rackId]) {
                    rackPositions[rackId] = {
                        x: 34 + (rackIndex % 3) * 230,
                        y: 78 + Math.floor(rackIndex / 3) * 440
                    };
                }
            });
        });
    }

    public get canvasVisibleZones(): any[] {
        if (this.canvasScopeId === -1) return this.canvasZones;
        return this.canvasZones.filter(
            (zone: any) => Number(zone?.id || 0) === Number(this.canvasScopeId)
        );
    }

    public canvasRacksForZone(zone: any): any[] {
        return this.canvasRacks.filter(
            (rack: any) => Number(rack?.zone_id || 0) === Number(zone?.id || 0)
        );
    }

    public canvasZonePosition(zone: any): any {
        return this.canvasLayout.zone_positions[String(Number(zone?.id || 0))] || {
            x: 0,
            y: 0,
            width: 760,
            height: 560
        };
    }

    public canvasRackPosition(rack: any): any {
        return this.canvasLayout.rack_positions[String(Number(rack?.rack_record_id || 0))] || {
            x: 0,
            y: 0
        };
    }

    private canvasElementKey(elementType: string, element: any): string {
        if (elementType === 'zone') {
            return `zone:${Number(element?.id || 0)}`;
        }
        if (elementType === 'rack') {
            return `rack:${Number(element?.rack_record_id || 0)}`;
        }
        const requestedType = String(element?.item_type || '');
        const itemType = ['device', 'chassis'].includes(requestedType)
            ? requestedType
            : 'node';
        return `${itemType}:${Number(element?.id || 0)}`;
    }

    private canvasDefaultElementStyle(elementType: string, element: any): any {
        if (elementType === 'zone') {
            return {
                font_size: 13,
                shape: 'rounded',
                color: Number(element?.id || 0) === 0 ? '#f59e0b' : '#6366f1'
            };
        }
        if (elementType === 'rack') {
            const rackColors: any = {
                deployed: '#16a34a',
                ready: '#2563eb',
                deploying: '#ea580c',
                failed: '#e11d48',
                waiting: '#64748b',
                empty: '#a1a1aa',
            };
            return {
                font_size: 10,
                shape: 'rounded',
                color: rackColors[String(element?.status || '')] || '#64748b'
            };
        }
        const deploymentColors: any = {
            deployed: '#16a34a',
            ready: '#2563eb',
            deploying: '#ea580c',
            failed: '#e11d48',
            waiting: '#64748b',
            not_applicable: '#a1a1aa',
        };
        const color = deploymentColors[
            String(element?.deployment_state?.key || 'waiting')
        ] || '#64748b';
        return {
            font_size: 6,
            shape: 'soft',
            color
        };
    }

    private canvasElementStyleFromLayout(layout: any, elementType: string, element: any): any {
        const key = this.canvasElementKey(elementType, element);
        const custom = layout?.element_styles?.[key] || {};
        return {
            ...this.canvasDefaultElementStyle(elementType, element),
            ...custom
        };
    }

    public canvasElementStyle(elementType: string, element: any): any {
        return this.canvasElementStyleFromLayout(this.canvasLayout, elementType, element);
    }

    public miniCanvasElementStyle(elementType: string, element: any): any {
        return this.canvasElementStyleFromLayout(this.miniCanvasLayout, elementType, element);
    }

    public canvasElementShape(elementType: string, element: any): string {
        return String(this.canvasElementStyle(elementType, element).shape || 'rounded');
    }

    public canvasElementFontSize(elementType: string, element: any): number {
        return Number(this.canvasElementStyle(elementType, element).font_size || 10);
    }

    public miniCanvasElementShape(elementType: string, element: any): string {
        return String(this.miniCanvasElementStyle(elementType, element).shape || 'rounded');
    }

    public miniCanvasElementFontSize(elementType: string, element: any): number {
        return Number(this.miniCanvasElementStyle(elementType, element).font_size || 10);
    }

    private canvasElementBorderColorFromLayout(
        layout: any,
        elementType: string,
        element: any
    ): string | null {
        const key = this.canvasElementKey(elementType, element);
        return layout?.element_styles?.[key]?.color || null;
    }

    public canvasElementBorderColor(elementType: string, element: any): string | null {
        return this.canvasElementBorderColorFromLayout(
            this.canvasLayout,
            elementType,
            element
        );
    }

    public miniCanvasElementBorderColor(elementType: string, element: any): string | null {
        return this.canvasElementBorderColorFromLayout(
            this.miniCanvasLayout,
            elementType,
            element
        );
    }

    private canvasElementFillFromLayout(
        layout: any,
        elementType: string,
        element: any
    ): string | null {
        const color = this.canvasElementBorderColorFromLayout(layout, elementType, element);
        if (!color) return null;
        const hex = color.replace('#', '');
        const red = parseInt(hex.slice(0, 2), 16);
        const green = parseInt(hex.slice(2, 4), 16);
        const blue = parseInt(hex.slice(4, 6), 16);
        if ([red, green, blue].some((value: number) => Number.isNaN(value))) return null;
        const alpha = elementType === 'item' ? 0.32 : 0.14;
        return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
    }

    public canvasElementFill(elementType: string, element: any): string | null {
        return this.canvasElementFillFromLayout(this.canvasLayout, elementType, element);
    }

    public miniCanvasElementFill(elementType: string, element: any): string | null {
        return this.canvasElementFillFromLayout(
            this.miniCanvasLayout,
            elementType,
            element
        );
    }

    public selectCanvasElement(elementType: string, element: any) {
        if (!this.canvasEdit || this.canvasTool !== 'select') return;
        this.canvasTool = 'select';
        const key = this.canvasElementKey(elementType, element);
        const keyId = Number(key.split(':')[1] || 0);
        if ((elementType !== 'zone' && keyId <= 0) || keyId < 0) return;
        let label = String(element?.name || '선택 요소');
        let typeLabel = element?.item_type === 'device'
            ? '네트워크 장비'
            : (element?.item_type === 'chassis' ? 'Chassis' : 'Node');
        if (elementType === 'zone') {
            label = this.zoneNavigatorLabel(element);
            typeLabel = 'Zone';
        } else if (elementType === 'rack') {
            label = this.rackNavigatorName(element);
            typeLabel = 'Rack';
        }
        this.canvasSelection = {
            key,
            source_type: elementType,
            element,
            label,
            type_label: typeLabel
        };
        this.service.render();
    }

    public clearCanvasSelection() {
        this.canvasSelection = null;
        this.service.render();
    }

    public isCanvasElementSelected(elementType: string, element: any): boolean {
        return Boolean(
            this.canvasSelection
            && this.canvasSelection.key === this.canvasElementKey(elementType, element)
        );
    }

    public get selectedCanvasStyle(): any {
        if (!this.canvasSelection || this.canvasSelection.source_type === 'object') return null;
        return this.canvasElementStyle(
            this.canvasSelection.source_type,
            this.canvasSelection.element
        );
    }

    public get selectedCanvasShapeOptions(): any[] {
        if (this.canvasSelection?.source_type === 'item') return this.canvasShapeOptions;
        return this.canvasShapeOptions.filter((option: any) => option.value !== 'pill');
    }

    public get selectedCanvasFontMin(): number {
        if (this.canvasSelection?.source_type === 'zone') return 9;
        if (this.canvasSelection?.source_type === 'rack') return 8;
        return 6;
    }

    public get selectedCanvasFontMax(): number {
        if (this.canvasSelection?.source_type === 'zone') return 28;
        if (this.canvasSelection?.source_type === 'rack') return 20;
        return 14;
    }

    public updateSelectedCanvasStyle(field: string, value: any) {
        if (!this.canvasEdit || !this.canvasSelection || this.canvasSelection.source_type === 'object') return;
        const key = String(this.canvasSelection.key);
        const next = {
            ...(this.canvasLayout.element_styles[key] || {})
        };
        if (field === 'font_size') {
            const fontSize = Number(value);
            if (!Number.isFinite(fontSize)) return;
            next.font_size = Math.round(Math.min(
                this.selectedCanvasFontMax,
                Math.max(this.selectedCanvasFontMin, fontSize)
            ));
        } else if (field === 'shape') {
            if (!this.selectedCanvasShapeOptions.some((option: any) => option.value === value)) return;
            next.shape = String(value);
        } else if (field === 'color') {
            const color = String(value || '').trim().toLowerCase();
            if (!/^#[0-9a-f]{6}$/.test(color)) return;
            next.color = color;
        } else {
            return;
        }
        this.canvasLayout.element_styles[key] = next;
        this.canvasChanged = true;
        this.canvasMessage = `${this.canvasSelection.label} 스타일을 변경했습니다. 저장 버튼을 눌러 반영하세요.`;
        this.service.render();
    }

    public resetSelectedCanvasStyle() {
        if (!this.canvasEdit || !this.canvasSelection || this.canvasSelection.source_type === 'object') return;
        const key = String(this.canvasSelection.key);
        if (!this.canvasLayout.element_styles[key]) return;
        delete this.canvasLayout.element_styles[key];
        this.canvasChanged = true;
        this.canvasMessage = `${this.canvasSelection.label} 스타일을 기본값으로 되돌렸습니다. 저장 버튼을 눌러 반영하세요.`;
        this.service.render();
    }

    private normalizeCanvasRotation(value: any): number {
        const rotation = Number(value);
        if (!Number.isFinite(rotation)) return 0;
        return Math.round((((rotation % 360) + 360) % 360) * 10) / 10;
    }

    private clampCanvasCoordinate(value: any): number {
        const coordinate = Number(value);
        if (!Number.isFinite(coordinate)) return 0;
        return Math.round(Math.min(12000, Math.max(0, coordinate)));
    }

    private snapCanvasCoordinate(
        value: any,
        minimum: number = 0,
        maximum: number = 12000
    ): number {
        const coordinate = Number(value);
        const safeMinimum = Number.isFinite(Number(minimum)) ? Number(minimum) : 0;
        const safeMaximum = Number.isFinite(Number(maximum))
            ? Math.max(safeMinimum, Number(maximum))
            : 12000;
        const clamped = Math.min(
            safeMaximum,
            Math.max(safeMinimum, Number.isFinite(coordinate) ? coordinate : safeMinimum)
        );
        if (!this.canvasGridEnabled) return Math.round(clamped);
        const gridSize = Math.max(1, Number(this.canvasGridSize || 40));
        const firstGrid = Math.ceil(safeMinimum / gridSize) * gridSize;
        const lastGrid = Math.floor(safeMaximum / gridSize) * gridSize;
        if (lastGrid < firstGrid) return Math.round(clamped);
        return Math.round(Math.min(
            lastGrid,
            Math.max(firstGrid, Math.round(clamped / gridSize) * gridSize)
        ));
    }

    private snapCanvasPoint(point: any): any {
        return {
            x: this.snapCanvasCoordinate(point?.x),
            y: this.snapCanvasCoordinate(point?.y)
        };
    }

    private ensureCanvasObjectDefaults(layout: any = this.canvasLayout) {
        for (const object of (layout?.canvas_objects || [])) {
            object.rotation = this.normalizeCanvasRotation(object?.rotation || 0);
            if (object?.type !== 'arrow') continue;
            const x = Number(object?.x || 0);
            const y = Number(object?.y || 0);
            const width = Math.max(20, Number(object?.width || 180));
            const height = Math.max(20, Number(object?.height || 20));
            if (!Number.isFinite(Number(object?.start_x))) object.start_x = x;
            if (!Number.isFinite(Number(object?.start_y))) object.start_y = y + height / 2;
            if (!Number.isFinite(Number(object?.end_x))) object.end_x = x + width;
            if (!Number.isFinite(Number(object?.end_y))) object.end_y = y + height / 2;
            this.syncCanvasArrowBounds(object);
        }
    }

    private canvasArrowDistance(object: any): number {
        return Math.hypot(
            Number(object?.end_x || 0) - Number(object?.start_x || 0),
            Number(object?.end_y || 0) - Number(object?.start_y || 0)
        );
    }

    private syncCanvasArrowBounds(object: any) {
        if (!object || object.type !== 'arrow') return;
        object.start_x = this.clampCanvasCoordinate(object.start_x);
        object.start_y = this.clampCanvasCoordinate(object.start_y);
        object.end_x = this.clampCanvasCoordinate(object.end_x);
        object.end_y = this.clampCanvasCoordinate(object.end_y);
        object.x = Math.min(object.start_x, object.end_x);
        object.y = Math.min(object.start_y, object.end_y);
        object.width = Math.max(20, Math.abs(object.end_x - object.start_x));
        object.height = Math.max(20, Math.abs(object.end_y - object.start_y));
        object.rotation = 0;
    }

    private setCanvasArrowPoint(object: any, endpoint: string, x: number, y: number) {
        if (!object || object.type !== 'arrow') return;
        const isEnd = endpoint === 'end';
        const otherX = Number(isEnd ? object.start_x : object.end_x);
        const otherY = Number(isEnd ? object.start_y : object.end_y);
        let nextX = this.clampCanvasCoordinate(x);
        let nextY = this.clampCanvasCoordinate(y);
        let deltaX = nextX - otherX;
        let deltaY = nextY - otherY;
        let distance = Math.hypot(deltaX, deltaY);
        if (distance < 20) {
            if (distance < 0.001) {
                deltaX = isEnd ? 20 : -20;
                deltaY = 0;
            } else {
                deltaX = deltaX / distance * 20;
                deltaY = deltaY / distance * 20;
            }
            nextX = otherX + deltaX;
            nextY = otherY + deltaY;
            if (nextX < 0 || nextX > 12000 || nextY < 0 || nextY > 12000) {
                nextX = otherX - deltaX;
                nextY = otherY - deltaY;
            }
            distance = 20;
        }
        if (distance > 4000) {
            const ratio = 4000 / distance;
            nextX = otherX + deltaX * ratio;
            nextY = otherY + deltaY * ratio;
        }
        if (isEnd) {
            object.end_x = nextX;
            object.end_y = nextY;
        } else {
            object.start_x = nextX;
            object.start_y = nextY;
        }
        this.syncCanvasArrowBounds(object);
    }

    private setCanvasArrowEndpoints(
        object: any,
        startX: number,
        startY: number,
        endX: number,
        endY: number
    ) {
        let minimumX = Math.min(startX, endX);
        let maximumX = Math.max(startX, endX);
        let minimumY = Math.min(startY, endY);
        let maximumY = Math.max(startY, endY);
        let shiftX = minimumX < 0 ? -minimumX : 0;
        let shiftY = minimumY < 0 ? -minimumY : 0;
        if (maximumX + shiftX > 12000) shiftX -= maximumX + shiftX - 12000;
        if (maximumY + shiftY > 12000) shiftY -= maximumY + shiftY - 12000;
        object.start_x = startX + shiftX;
        object.start_y = startY + shiftY;
        object.end_x = endX + shiftX;
        object.end_y = endY + shiftY;
        this.syncCanvasArrowBounds(object);
    }

    public get canvasVisibleObjects(): any[] {
        const objects = Array.isArray(this.canvasLayout?.canvas_objects)
            ? this.canvasLayout.canvas_objects
            : [];
        return objects.filter(
            (object: any) => Number(object?.scope_id ?? -1) === Number(this.canvasScopeId)
        );
    }

    public trackCanvasObject(index: number, object: any): any {
        return object?.id || index;
    }

    public selectCanvasTool(tool: string) {
        if (!this.canvasEdit) return;
        if (!this.canvasPaintTools.some((option: any) => option.value === tool)) return;
        this.canvasTool = tool;
        this.canvasDrawing = null;
        this.canvasObjectDrag = null;
        if (tool !== 'select') this.canvasSelection = null;
        this.canvasMessage = tool === 'select'
            ? '요소를 선택해 이동하거나 스타일을 편집하세요.'
            : `${this.canvasPaintTools.find((option: any) => option.value === tool)?.label || '도형'} 도구: 캔버스 빈 공간을 드래그해 추가하세요.`;
        this.service.render();
    }

    private canvasObjectId(): string {
        return `object_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    }

    private canvasStagePoint(event: MouseEvent, snapToGrid: boolean = false): any {
        const stage = document.querySelector(
            '.rack-spatial-overlay .rack-spatial-stage'
        ) as HTMLElement | null;
        if (!stage) return null;
        const rect = stage.getBoundingClientRect();
        const scale = Math.max(0.25, this.canvasZoomPercent / 100);
        const point = {
            x: Math.round(Math.min(12000, Math.max(0, (event.clientX - rect.left) / scale))),
            y: Math.round(Math.min(12000, Math.max(0, (event.clientY - rect.top) / scale)))
        };
        return snapToGrid ? this.snapCanvasPoint(point) : point;
    }

    private newCanvasObject(type: string, x: number, y: number): any {
        const isText = type === 'text';
        const object: any = {
            id: this.canvasObjectId(),
            type,
            scope_id: Number(this.canvasScopeId),
            x,
            y,
            width: 20,
            height: 20,
            fill: isText ? '#ffffff' : '#6366f1',
            stroke: isText ? '#1e293b' : '#4338ca',
            stroke_width: 2,
            opacity: isText ? 0.95 : (type === 'arrow' ? 0.9 : 0.4),
            layer: 'front',
            font_size: 20,
            rotation: 0,
            text: isText ? '텍스트' : '',
            asset: ''
        };
        if (type === 'arrow') {
            object.start_x = x;
            object.start_y = y;
            object.end_x = Math.min(12000, x + 20);
            object.end_y = y;
            this.syncCanvasArrowBounds(object);
        }
        return object;
    }

    public startCanvasObjectDrawing(event: MouseEvent) {
        if (!this.canvasEdit || event.button !== 0 || this.canvasTool === 'select') return;
        if ((this.canvasLayout?.canvas_objects || []).length >= 500) {
            this.canvasMessage = '캔버스에는 최대 500개의 오브젝트를 추가할 수 있습니다.';
            this.service.render();
            return;
        }
        const target = event.target as HTMLElement;
        if (target.closest('.rack-canvas-object')) return;
        const point = this.canvasStagePoint(event, true);
        if (!point) return;
        event.preventDefault();
        event.stopPropagation();
        const object = this.newCanvasObject(this.canvasTool, point.x, point.y);
        this.canvasLayout.canvas_objects.push(object);
        this.canvasDrawing = {
            id: object.id,
            startX: point.x,
            startY: point.y,
            moved: false
        };
        this.canvasChanged = true;
        this.canvasMessage = `${this.canvasObjectTypeLabel(object)}을(를) 추가했습니다. 우측 패널에서 스타일을 편집할 수 있습니다.`;
        this.selectCanvasObject(object);
    }

    private finishCanvasObjectDrawing() {
        if (!this.canvasDrawing) return;
        const object = this.canvasObjectById(this.canvasDrawing.id);
        if (object?.type === 'arrow') {
            if (!this.canvasDrawing.moved || this.canvasArrowDistance(object) < 20) {
                const endX = Number(object.start_x) <= 11820
                    ? Number(object.start_x) + 180
                    : Number(object.start_x) - 180;
                this.setCanvasArrowPoint(object, 'end', endX, Number(object.start_y));
            } else {
                this.syncCanvasArrowBounds(object);
            }
        } else if (object && !this.canvasDrawing.moved) {
            const defaults: any = {
                rect: { width: 180, height: 110 },
                ellipse: { width: 160, height: 110 },
                text: { width: 180, height: 56 }
            };
            const size = defaults[object.type] || defaults.rect;
            object.width = size.width;
            object.height = size.height;
        }
        this.canvasDrawing = null;
    }

    private canvasObjectById(id: string): any {
        return (this.canvasLayout?.canvas_objects || []).find(
            (object: any) => String(object?.id) === String(id)
        ) || null;
    }

    public selectCanvasObject(object: any) {
        if (!this.canvasEdit || !object) return;
        this.canvasSelection = {
            key: `object:${String(object.id)}`,
            source_type: 'object',
            element: object,
            label: object.type === 'text' ? String(object.text || '텍스트') : this.canvasObjectTypeLabel(object),
            type_label: '캔버스 오브젝트'
        };
        this.service.render();
    }

    public isCanvasObjectSelected(object: any): boolean {
        return Boolean(
            this.canvasSelection?.source_type === 'object'
            && this.canvasSelection.key === `object:${String(object?.id)}`
        );
    }

    public get selectedCanvasObject(): any {
        if (this.canvasSelection?.source_type !== 'object') return null;
        return this.canvasObjectById(String(this.canvasSelection?.element?.id || ''));
    }

    public canvasObjectTypeLabel(object: any): string {
        const labels: any = {
            rect: '사각형',
            ellipse: '원형',
            arrow: '화살표',
            text: '텍스트',
            image: '이미지'
        };
        return labels[String(object?.type || '')] || '오브젝트';
    }

    public canvasObjectBackground(object: any): string {
        if (object?.type === 'arrow') return 'transparent';
        if (object?.type === 'image') return '#ffffff';
        return String(object?.fill || '#6366f1');
    }

    public canvasObjectBorderWidth(object: any): number {
        if (object?.type === 'arrow') return 0;
        return Number(object?.stroke_width || 0);
    }

    public canvasObjectRotation(object: any): number {
        if (object?.type === 'arrow') {
            const rotation = Math.atan2(
                Number(object?.end_y || 0) - Number(object?.start_y || 0),
                Number(object?.end_x || 0) - Number(object?.start_x || 0)
            ) * 180 / Math.PI;
            return this.normalizeCanvasRotation(rotation);
        }
        return this.normalizeCanvasRotation(object?.rotation || 0);
    }

    public canvasObjectTransform(object: any): string {
        if (object?.type === 'arrow') return 'none';
        return `rotate(${this.canvasObjectRotation(object)}deg)`;
    }

    public canvasArrowLocalPoint(object: any, endpoint: string, axis: string): number {
        const key = `${endpoint}_${axis}`;
        const origin = axis === 'x' ? Number(object?.x || 0) : Number(object?.y || 0);
        return Number(object?.[key] || 0) - origin;
    }

    public canvasArrowHeadPoints(object: any): string {
        const startX = this.canvasArrowLocalPoint(object, 'start', 'x');
        const startY = this.canvasArrowLocalPoint(object, 'start', 'y');
        const endX = this.canvasArrowLocalPoint(object, 'end', 'x');
        const endY = this.canvasArrowLocalPoint(object, 'end', 'y');
        const deltaX = endX - startX;
        const deltaY = endY - startY;
        const distance = Math.max(1, Math.hypot(deltaX, deltaY));
        const unitX = deltaX / distance;
        const unitY = deltaY / distance;
        const headLength = Math.min(18, Math.max(10, Number(object?.stroke_width || 2) * 2 + 8));
        const headWidth = headLength * 0.58;
        const baseX = endX - unitX * headLength;
        const baseY = endY - unitY * headLength;
        const perpendicularX = -unitY;
        const perpendicularY = unitX;
        return [
            `${endX},${endY}`,
            `${baseX + perpendicularX * headWidth},${baseY + perpendicularY * headWidth}`,
            `${baseX - perpendicularX * headWidth},${baseY - perpendicularY * headWidth}`
        ].join(' ');
    }

    public canvasObjectOpacityPercent(object: any): number {
        return Math.round(Number(object?.opacity || 0) * 100);
    }

    public canvasObjectImageUrl(object: any): string {
        const filename = String(object?.asset || '');
        if (!filename) return '';
        return `/wiz/api/page.kiera.rack/canvas_background?action=asset&filename=${encodeURIComponent(filename)}`;
    }

    public startCanvasObjectDrag(event: MouseEvent, object: any) {
        if (!this.canvasEdit || event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.canvasTool = 'select';
        this.selectCanvasObject(object);
        this.canvasObjectDrag = {
            type: 'move',
            id: String(object.id),
            clientX: event.clientX,
            clientY: event.clientY,
            x: Number(object.x),
            y: Number(object.y),
            startX: Number(object.start_x),
            startY: Number(object.start_y),
            endX: Number(object.end_x),
            endY: Number(object.end_y)
        };
    }

    public startCanvasObjectResize(event: MouseEvent, object: any) {
        if (!this.canvasEdit || object?.type === 'arrow' || event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.canvasTool = 'select';
        this.selectCanvasObject(object);
        this.canvasObjectDrag = {
            type: 'resize',
            id: String(object.id),
            clientX: event.clientX,
            clientY: event.clientY,
            width: Number(object.width),
            height: Number(object.height),
            rotation: this.canvasObjectRotation(object)
        };
    }

    private canvasObjectCenter(object: any): any {
        if (object?.type === 'arrow') {
            return {
                x: (Number(object.start_x) + Number(object.end_x)) / 2,
                y: (Number(object.start_y) + Number(object.end_y)) / 2
            };
        }
        return {
            x: Number(object?.x || 0) + Number(object?.width || 0) / 2,
            y: Number(object?.y || 0) + Number(object?.height || 0) / 2
        };
    }

    public startCanvasObjectRotate(event: MouseEvent, object: any) {
        if (!this.canvasEdit || event.button !== 0) return;
        const point = this.canvasStagePoint(event);
        if (!point) return;
        event.preventDefault();
        event.stopPropagation();
        this.canvasTool = 'select';
        this.selectCanvasObject(object);
        const center = this.canvasObjectCenter(object);
        this.canvasObjectDrag = {
            type: 'rotate',
            id: String(object.id),
            centerX: center.x,
            centerY: center.y,
            pointerAngle: Math.atan2(point.y - center.y, point.x - center.x),
            rotation: this.canvasObjectRotation(object),
            startX: Number(object.start_x),
            startY: Number(object.start_y),
            endX: Number(object.end_x),
            endY: Number(object.end_y)
        };
    }

    public startCanvasArrowPointDrag(event: MouseEvent, object: any, endpoint: string) {
        if (!this.canvasEdit || object?.type !== 'arrow' || event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.canvasTool = 'select';
        this.selectCanvasObject(object);
        this.canvasObjectDrag = {
            type: 'arrow-point',
            id: String(object.id),
            endpoint: endpoint === 'start' ? 'start' : 'end'
        };
    }

    private rotateCanvasArrow(object: any, deltaDegrees: number, source: any = null) {
        const center = source
            ? {
                x: Number(source.centerX ?? source.x),
                y: Number(source.centerY ?? source.y)
            }
            : this.canvasObjectCenter(object);
        const radians = deltaDegrees * Math.PI / 180;
        const cosine = Math.cos(radians);
        const sine = Math.sin(radians);
        const rotatePoint = (x: number, y: number): any => {
            const offsetX = x - center.x;
            const offsetY = y - center.y;
            return {
                x: center.x + offsetX * cosine - offsetY * sine,
                y: center.y + offsetX * sine + offsetY * cosine
            };
        };
        const start = rotatePoint(
            Number(source?.startX ?? object.start_x),
            Number(source?.startY ?? object.start_y)
        );
        const end = rotatePoint(
            Number(source?.endX ?? object.end_x),
            Number(source?.endY ?? object.end_y)
        );
        this.setCanvasArrowEndpoints(object, start.x, start.y, end.x, end.y);
    }

    public updateSelectedCanvasObject(field: string, value: any) {
        const object = this.selectedCanvasObject;
        if (!this.canvasEdit || !object) return;
        if (field === 'text') {
            object.text = String(value || '').slice(0, 240);
            this.canvasSelection.label = object.text || '텍스트';
        } else if (field === 'fill' || field === 'stroke') {
            const color = String(value || '').trim().toLowerCase();
            if (!/^#[0-9a-f]{6}$/.test(color)) return;
            object[field] = color;
        } else if (field === 'font_size') {
            const fontSize = Number(value);
            if (!Number.isFinite(fontSize)) return;
            object.font_size = Math.round(Math.min(72, Math.max(8, fontSize)));
        } else if (field === 'stroke_width') {
            const strokeWidth = Number(value);
            if (!Number.isFinite(strokeWidth)) return;
            object.stroke_width = Math.round(Math.min(12, Math.max(0, strokeWidth)));
        } else if (field === 'opacity') {
            const opacity = Number(value);
            if (!Number.isFinite(opacity)) return;
            object.opacity = Math.round(Math.min(1, Math.max(0.1, opacity)) * 100) / 100;
        } else if (field === 'rotation') {
            const rotation = this.normalizeCanvasRotation(value);
            if (object.type === 'arrow') {
                this.rotateCanvasArrow(
                    object,
                    rotation - this.canvasObjectRotation(object)
                );
            } else {
                object.rotation = rotation;
            }
        } else if (field === 'layer') {
            if (value !== 'behind' && value !== 'front') return;
            object.layer = value;
        } else {
            return;
        }
        this.canvasChanged = true;
        this.canvasMessage = `${this.canvasObjectTypeLabel(object)} 스타일을 변경했습니다. 저장 버튼을 눌러 반영하세요.`;
        this.service.render();
    }

    public deleteSelectedCanvasObject() {
        const object = this.selectedCanvasObject;
        if (!this.canvasEdit || !object) return;
        const index = this.canvasLayout.canvas_objects.findIndex(
            (item: any) => String(item?.id) === String(object.id)
        );
        if (index < 0) return;
        this.canvasLayout.canvas_objects.splice(index, 1);
        this.canvasSelection = null;
        this.canvasChanged = true;
        this.canvasMessage = `${this.canvasObjectTypeLabel(object)}을(를) 삭제했습니다. 저장 버튼을 눌러 반영하세요.`;
        this.service.render();
    }

    private canvasObjectOuterEdge(object: any, axis: string): number {
        if (object?.type === 'arrow') {
            return axis === 'x'
                ? Math.max(Number(object.start_x), Number(object.end_x))
                : Math.max(Number(object.start_y), Number(object.end_y));
        }
        const width = Number(object?.width || 0);
        const height = Number(object?.height || 0);
        const radians = this.canvasObjectRotation(object) * Math.PI / 180;
        const rotatedWidth = Math.abs(width * Math.cos(radians))
            + Math.abs(height * Math.sin(radians));
        const rotatedHeight = Math.abs(width * Math.sin(radians))
            + Math.abs(height * Math.cos(radians));
        return axis === 'x'
            ? Number(object?.x || 0) + width / 2 + rotatedWidth / 2
            : Number(object?.y || 0) + height / 2 + rotatedHeight / 2;
    }

    public get canvasContentWidth(): number {
        if (this.canvasScopeId === -1) {
            return Math.max(1600, ...this.canvasVisibleZones.map((zone: any) => {
                const position = this.canvasZonePosition(zone);
                return Number(position.x) + Number(position.width) + 100;
            }), ...this.canvasVisibleObjects.map((object: any) => (
                this.canvasObjectOuterEdge(object, 'x') + 100
            )));
        }
        return Math.max(
            1500,
            ...this.canvasRacks.map((rack: any) => (
                Number(this.canvasRackPosition(rack).x) + 320
            )),
            ...this.canvasVisibleObjects.map((object: any) => (
                this.canvasObjectOuterEdge(object, 'x') + 100
            ))
        );
    }

    public get canvasContentHeight(): number {
        if (this.canvasScopeId === -1) {
            return Math.max(1000, ...this.canvasVisibleZones.map((zone: any) => {
                const position = this.canvasZonePosition(zone);
                return Number(position.y) + Number(position.height) + 100;
            }), ...this.canvasVisibleObjects.map((object: any) => (
                this.canvasObjectOuterEdge(object, 'y') + 100
            )));
        }
        return Math.max(
            900,
            ...this.canvasRacks.map((rack: any) => (
                Number(this.canvasRackPosition(rack).y)
                + this.canvasRackBodyHeight(rack)
                + 200
            )),
            ...this.canvasVisibleObjects.map((object: any) => (
                this.canvasObjectOuterEdge(object, 'y') + 100
            ))
        );
    }

    public get canvasTransform(): string {
        return `translate(${this.canvasPanX}px, ${this.canvasPanY}px) scale(${this.canvasZoomPercent / 100})`;
    }

    public get canvasGridBackgroundSize(): string {
        const scale = Math.max(0.25, this.canvasZoomPercent / 100);
        const size = this.canvasGridSize * scale;
        return `${size}px ${size}px`;
    }

    public get canvasGridBackgroundPosition(): string {
        return `${this.canvasPanX}px ${this.canvasPanY}px`;
    }

    public get canvasBackgroundStyle(): string {
        const filename = String(this.canvasLayout?.background_image || '');
        if (!filename) return 'none';
        const url = `/wiz/api/page.kiera.rack/canvas_background?action=view&v=${encodeURIComponent(filename)}`;
        return `linear-gradient(rgba(248,250,252,.78), rgba(248,250,252,.78)), url("${url}")`;
    }

    public async changeCanvasGridSize(value: any) {
        const requestedSize = Number(value);
        if (!Number.isFinite(requestedSize)) return;
        const nextSize = Math.round(Math.min(
            this.canvasGridMaxSize,
            Math.max(this.canvasGridMinSize, requestedSize)
        ));
        this.canvasGridSize = nextSize;
        this.canvasMessage = this.canvasGridEnabled
            ? `${nextSize}px 자석 격자로 변경했습니다. 모든 요소의 왼쪽 위 꼭짓점이 이 격자에 맞춰집니다.`
            : `${nextSize}px 격자로 설정했습니다. 격자를 켜면 표시와 자석 스냅에 함께 적용됩니다.`;
        await this.service.render();
    }

    public async toggleCanvasGrid() {
        this.canvasGridEnabled = !this.canvasGridEnabled;
        this.canvasMessage = this.canvasEdit
            ? (this.canvasGridEnabled
                ? `${this.canvasGridSize}px 격자 표시와 자석 스냅을 켰습니다.`
                : '격자 표시와 자석 스냅을 껐습니다. 요소를 자유롭게 이동할 수 있습니다.')
            : (this.canvasGridEnabled
                ? `${this.canvasGridSize}px 전체 격자를 표시합니다.`
                : '전체 격자를 숨겼습니다. Edit Mode 진입 전에도 다시 켤 수 있습니다.');
        await this.service.render();
    }

    public async canvasZoomIn() {
        this.canvasZoomPercent = Math.min(150, this.canvasZoomPercent + 10);
        await this.service.render();
    }

    public async canvasZoomOut() {
        this.canvasZoomPercent = Math.max(25, this.canvasZoomPercent - 10);
        await this.service.render();
    }

    public async onCanvasViewportWheel(event: WheelEvent) {
        if (this.canvasLoading || event.deltaY === 0) return;
        const target = event.target as HTMLElement | null;
        if (target?.closest('.rack-canvas-inspector, .rack-canvas-paint-tools, select, input, textarea')) return;
        const viewport = event.currentTarget as HTMLElement | null;
        if (!viewport) return;
        event.preventDefault();

        const currentZoom = Math.min(150, Math.max(25, this.canvasZoomPercent));
        const nextZoom = Math.min(
            150,
            Math.max(25, currentZoom + (event.deltaY < 0 ? 10 : -10))
        );
        if (nextZoom === currentZoom) return;

        const rect = viewport.getBoundingClientRect();
        const pointerX = event.clientX - rect.left;
        const pointerY = event.clientY - rect.top;
        const currentScale = currentZoom / 100;
        const nextScale = nextZoom / 100;
        const canvasX = (pointerX - this.canvasPanX) / currentScale;
        const canvasY = (pointerY - this.canvasPanY) / currentScale;
        this.canvasZoomPercent = nextZoom;
        this.canvasPanX = Math.round(pointerX - canvasX * nextScale);
        this.canvasPanY = Math.round(pointerY - canvasY * nextScale);
        await this.service.render();
    }

    public async fitCanvas() {
        const viewport = document.querySelector('.rack-spatial-viewport') as HTMLElement | null;
        if (!viewport) return;
        const scale = Math.min(
            1,
            Math.max(
                0.25,
                Math.min(
                    (viewport.clientWidth - 48) / this.canvasContentWidth,
                    (viewport.clientHeight - 48) / this.canvasContentHeight
                )
            )
        );
        this.canvasZoomPercent = Math.round(scale * 100);
        this.canvasPanX = 24;
        this.canvasPanY = 24;
        await this.service.render();
    }

    public startCanvasEdit() {
        if (this.canvasLoading) return;
        this.canvasOriginal = this.canvasSnapshot();
        this.canvasEdit = true;
        this.canvasSelection = null;
        this.canvasTool = 'select';
        this.canvasMessage = this.canvasGridEnabled
            ? `${this.canvasGridSize}px 자석 격자가 켜졌습니다. 이동하는 요소의 왼쪽 위 꼭짓점이 가장 가까운 격자 교차점에 맞춰집니다.`
            : '격자가 꺼져 있습니다. 상단의 격자 버튼을 누르면 표시와 자석 스냅을 함께 켤 수 있습니다.';
        this.service.render();
    }

    public discardCanvasEdit() {
        if (this.canvasOriginal) {
            this.canvasLayout = this.deepClone(this.canvasOriginal.layout);
            this.canvasRacks = this.deepClone(this.canvasOriginal.racks);
            this.canvasMoves = this.deepClone(this.canvasOriginal.moves || {});
        }
        this.canvasChanged = false;
        this.canvasEdit = false;
        this.canvasDrag = null;
        this.canvasDrawing = null;
        this.canvasObjectDrag = null;
        this.canvasDraggedItem = null;
        this.canvasDropShadow = null;
        this.canvasSelection = null;
        this.canvasTool = 'select';
        this.canvasMessage = '저장하지 않은 변경을 취소했습니다.';
        this.service.render();
    }

    public async saveCanvasEdit() {
        if (this.canvasSaving || !this.canvasEdit) return;
        this.canvasSaving = true;
        this.canvasMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save_canvas', {
                data: JSON.stringify({
                    zone_positions: this.canvasLayout.zone_positions,
                    rack_positions: this.canvasLayout.rack_positions,
                    element_styles: this.canvasLayout.element_styles,
                    canvas_objects: this.canvasLayout.canvas_objects,
                    moves: Object.keys(this.canvasMoves).map(
                        (key: string) => this.canvasMoves[key]
                    )
                })
            });
            if (code !== 200) {
                this.canvasMessage = data?.message || 'Rack 배치 변경을 저장하지 못했습니다.';
                return;
            }
            this.canvasLayout = this.deepClone(data?.canvas || this.canvasLayout);
            this.canvasMessage = 'Zone·Rack 위치와 크기, 장비 배치, 캔버스 오브젝트를 저장했습니다.';
            this.canvasEdit = false;
            this.canvasChanged = false;
            this.canvasMoves = {};
            this.canvasTool = 'select';
            await this.load(false);
            await this.loadCanvasScope(this.canvasScopeId);
        } catch (error) {
            this.canvasMessage = String(error || 'Rack 배치 변경을 저장하지 못했습니다.');
        } finally {
            this.canvasSaving = false;
            await this.service.render();
        }
    }

    public async uploadCanvasBackground() {
        if (!this.canvasEdit || this.canvasSaving) return;
        const files: any = await this.service.file.select({
            accept: 'image/png,image/jpeg,image/webp',
            multiple: false
        });
        const file = files && files.length ? files[0] : null;
        if (!file) return;
        if (file.size > 10 * 1024 * 1024) {
            this.canvasMessage = '배경 이미지는 10MB 이하여야 합니다.';
            await this.service.render();
            return;
        }
        const form = new FormData();
        form.append('action', 'upload');
        form.append('file', file);
        this.canvasSaving = true;
        await this.service.render();
        try {
            const response: any = await this.service.file.upload(
                '/wiz/api/page.kiera.rack/canvas_background',
                form
            );
            if (response?.code !== 200) {
                this.canvasMessage = response?.data?.message || response?.message || '배경 이미지를 저장하지 못했습니다.';
                return;
            }
            this.canvasLayout.background_image = response?.data?.canvas?.background_image || '';
            this.miniCanvasLayout.background_image = this.canvasLayout.background_image;
            this.canvasMessage = '캔버스 배경 이미지를 저장했습니다.';
        } finally {
            this.canvasSaving = false;
            await this.service.render();
        }
    }

    public async removeCanvasBackground() {
        if (!this.canvasEdit || this.canvasSaving || !this.canvasLayout?.background_image) return;
        this.canvasSaving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('canvas_background', {
                action: 'remove'
            });
            if (code !== 200) {
                this.canvasMessage = data?.message || '배경 이미지를 삭제하지 못했습니다.';
                return;
            }
            this.canvasLayout.background_image = '';
            this.miniCanvasLayout.background_image = '';
            this.canvasMessage = '캔버스 배경 이미지를 삭제했습니다.';
        } finally {
            this.canvasSaving = false;
            await this.service.render();
        }
    }

    public async addCanvasImage() {
        if (!this.canvasEdit || this.canvasSaving) return;
        if ((this.canvasLayout?.canvas_objects || []).length >= 500) {
            this.canvasMessage = '캔버스에는 최대 500개의 오브젝트를 추가할 수 있습니다.';
            await this.service.render();
            return;
        }
        const files: any = await this.service.file.select({
            accept: 'image/png,image/jpeg,image/webp',
            multiple: false
        });
        const file = files && files.length ? files[0] : null;
        if (!file) return;
        if (file.size > 10 * 1024 * 1024) {
            this.canvasMessage = '캔버스 이미지는 10MB 이하여야 합니다.';
            await this.service.render();
            return;
        }

        const form = new FormData();
        form.append('action', 'upload_asset');
        form.append('file', file);
        this.canvasSaving = true;
        this.canvasMessage = '캔버스 이미지를 업로드하는 중입니다.';
        await this.service.render();
        try {
            const response: any = await this.service.file.upload(
                '/wiz/api/page.kiera.rack/canvas_background',
                form
            );
            if (response?.code !== 200) {
                this.canvasMessage = response?.data?.message || response?.message || '캔버스 이미지를 추가하지 못했습니다.';
                return;
            }
            const viewport = document.querySelector(
                '.rack-spatial-overlay .rack-spatial-viewport'
            ) as HTMLElement | null;
            const scale = Math.max(0.25, this.canvasZoomPercent / 100);
            const x = this.snapCanvasCoordinate(viewport
                ? Math.max(0, (viewport.clientWidth / 2 - this.canvasPanX) / scale - 160)
                : 80);
            const y = this.snapCanvasCoordinate(viewport
                ? Math.max(0, (viewport.clientHeight / 2 - this.canvasPanY) / scale - 100)
                : 80);
            const object = {
                ...this.newCanvasObject('image', x, y),
                width: 320,
                height: 200,
                fill: '#ffffff',
                stroke: '#475569',
                stroke_width: 1,
                opacity: 1,
                asset: String(response?.data?.filename || '')
            };
            if (!object.asset) {
                this.canvasMessage = '업로드한 캔버스 이미지 정보를 확인하지 못했습니다.';
                return;
            }
            this.canvasLayout.canvas_objects.push(object);
            this.canvasTool = 'select';
            this.canvasChanged = true;
            this.canvasMessage = '이미지를 캔버스에 추가했습니다. 드래그하거나 우측 아래 핸들로 크기를 조절하세요.';
            this.selectCanvasObject(object);
        } catch (error) {
            this.canvasMessage = String(error || '캔버스 이미지를 추가하지 못했습니다.');
        } finally {
            this.canvasSaving = false;
            await this.service.render();
        }
    }

    public startCanvasZoneDrag(event: MouseEvent, zone: any) {
        if (!this.canvasEdit || this.canvasTool !== 'select' || this.canvasScopeId !== -1 || event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.canvasTool = 'select';
        const position = this.canvasZonePosition(zone);
        this.canvasDrag = {
            type: 'zone',
            id: String(Number(zone?.id || 0)),
            clientX: event.clientX,
            clientY: event.clientY,
            x: Number(position.x),
            y: Number(position.y)
        };
        this.service.render();
    }

    public startCanvasZoneResize(event: MouseEvent, zone: any) {
        if (!this.canvasEdit || this.canvasTool !== 'select' || this.canvasScopeId !== -1 || event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.canvasTool = 'select';
        const position = this.canvasZonePosition(zone);
        this.canvasDrag = {
            type: 'zone-resize',
            id: String(Number(zone?.id || 0)),
            clientX: event.clientX,
            clientY: event.clientY,
            width: Number(position.width),
            height: Number(position.height)
        };
    }

    public startCanvasRackDrag(event: MouseEvent, rack: any) {
        if (!this.canvasEdit || this.canvasTool !== 'select' || event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.canvasTool = 'select';
        const position = this.canvasRackPosition(rack);
        this.canvasDrag = {
            type: 'rack',
            id: String(Number(rack?.rack_record_id || 0)),
            zoneId: String(Number(rack?.zone_id || 0)),
            clientX: event.clientX,
            clientY: event.clientY,
            x: Number(position.x),
            y: Number(position.y)
        };
        this.service.render();
    }

    public onCanvasViewportMouseDown(event: MouseEvent) {
        if (event.button !== 0) return;
        if (this.canvasEdit && this.canvasTool !== 'select') return;
        const target = event.target as HTMLElement;
        if (target.closest('.rack-spatial-zone, .rack-spatial-rack, .rack-canvas-object, button, select, input, textarea')) return;
        event.preventDefault();
        if (this.canvasEdit) this.canvasSelection = null;
        this.canvasPanStart = {
            clientX: event.clientX,
            clientY: event.clientY,
            x: this.canvasPanX,
            y: this.canvasPanY
        };
    }

    public onCanvasViewportMouseMove(event: MouseEvent) {
        if (this.canvasDrawing) {
            const point = this.canvasStagePoint(event, true);
            const object = this.canvasObjectById(this.canvasDrawing.id);
            if (!point || !object) return;
            const deltaX = point.x - this.canvasDrawing.startX;
            const deltaY = point.y - this.canvasDrawing.startY;
            if (object.type === 'arrow') {
                this.setCanvasArrowPoint(object, 'end', point.x, point.y);
            } else {
                object.x = Math.min(point.x, this.canvasDrawing.startX);
                object.y = Math.min(point.y, this.canvasDrawing.startY);
                object.width = Math.round(Math.min(4000, Math.max(20, Math.abs(deltaX))));
                object.height = Math.round(Math.min(4000, Math.max(20, Math.abs(deltaY))));
            }
            this.canvasDrawing.moved = Math.abs(deltaX) >= 4 || Math.abs(deltaY) >= 4;
            this.canvasChanged = true;
            this.service.render();
            return;
        }
        if (this.canvasObjectDrag) {
            const object = this.canvasObjectById(this.canvasObjectDrag.id);
            if (!object) return;
            if (this.canvasObjectDrag.type === 'arrow-point') {
                const point = this.canvasStagePoint(event, true);
                if (!point) return;
                this.setCanvasArrowPoint(
                    object,
                    this.canvasObjectDrag.endpoint,
                    point.x,
                    point.y
                );
                this.canvasChanged = true;
                this.service.render();
                return;
            }
            if (this.canvasObjectDrag.type === 'rotate') {
                const point = this.canvasStagePoint(event);
                if (!point) return;
                const pointerAngle = Math.atan2(
                    point.y - this.canvasObjectDrag.centerY,
                    point.x - this.canvasObjectDrag.centerX
                );
                let deltaRadians = pointerAngle - this.canvasObjectDrag.pointerAngle;
                while (deltaRadians > Math.PI) deltaRadians -= Math.PI * 2;
                while (deltaRadians < -Math.PI) deltaRadians += Math.PI * 2;
                const deltaRotation = deltaRadians * 180 / Math.PI;
                if (object.type === 'arrow') {
                    this.rotateCanvasArrow(object, deltaRotation);
                } else {
                    object.rotation = this.normalizeCanvasRotation(
                        this.canvasObjectRotation(object) + deltaRotation
                    );
                }
                this.canvasObjectDrag.pointerAngle = pointerAngle;
                this.canvasChanged = true;
                this.service.render();
                return;
            }
            const scale = Math.max(0.25, this.canvasZoomPercent / 100);
            const deltaX = (event.clientX - this.canvasObjectDrag.clientX) / scale;
            const deltaY = (event.clientY - this.canvasObjectDrag.clientY) / scale;
            if (this.canvasObjectDrag.type === 'resize') {
                const radians = -Number(this.canvasObjectDrag.rotation || 0) * Math.PI / 180;
                const localDeltaX = deltaX * Math.cos(radians) - deltaY * Math.sin(radians);
                const localDeltaY = deltaX * Math.sin(radians) + deltaY * Math.cos(radians);
                object.width = Math.round(Math.min(
                    4000,
                    Math.max(20, this.canvasObjectDrag.width + localDeltaX)
                ));
                object.height = Math.round(Math.min(
                    4000,
                    Math.max(20, this.canvasObjectDrag.height + localDeltaY)
                ));
            } else if (object.type === 'arrow') {
                const snappedX = this.snapCanvasCoordinate(
                    this.canvasObjectDrag.x + deltaX
                );
                const snappedY = this.snapCanvasCoordinate(
                    this.canvasObjectDrag.y + deltaY
                );
                const snappedDeltaX = snappedX - this.canvasObjectDrag.x;
                const snappedDeltaY = snappedY - this.canvasObjectDrag.y;
                this.setCanvasArrowEndpoints(
                    object,
                    this.canvasObjectDrag.startX + snappedDeltaX,
                    this.canvasObjectDrag.startY + snappedDeltaY,
                    this.canvasObjectDrag.endX + snappedDeltaX,
                    this.canvasObjectDrag.endY + snappedDeltaY
                );
            } else {
                object.x = this.snapCanvasCoordinate(
                    this.canvasObjectDrag.x + deltaX
                );
                object.y = this.snapCanvasCoordinate(
                    this.canvasObjectDrag.y + deltaY
                );
            }
            this.canvasChanged = true;
            this.service.render();
            return;
        }
        if (this.canvasDrag) {
            const scale = Math.max(0.25, this.canvasZoomPercent / 100);
            const deltaX = (event.clientX - this.canvasDrag.clientX) / scale;
            const deltaY = (event.clientY - this.canvasDrag.clientY) / scale;
            if (this.canvasDrag.type === 'zone-resize') {
                const position = this.canvasLayout.zone_positions[this.canvasDrag.id];
                position.width = Math.round(Math.min(
                    this.canvasZoneMaxSize,
                    Math.max(this.canvasZoneMinWidth, this.canvasDrag.width + deltaX)
                ));
                position.height = Math.round(Math.min(
                    this.canvasZoneMaxSize,
                    Math.max(this.canvasZoneMinHeight, this.canvasDrag.height + deltaY)
                ));
            } else if (this.canvasDrag.type === 'zone') {
                const x = Math.max(0, this.canvasDrag.x + deltaX);
                const y = Math.max(0, this.canvasDrag.y + deltaY);
                const position = this.canvasLayout.zone_positions[this.canvasDrag.id];
                position.x = this.snapCanvasCoordinate(x);
                position.y = this.snapCanvasCoordinate(y);
            } else {
                const x = Math.max(0, this.canvasDrag.x + deltaX);
                const y = Math.max(0, this.canvasDrag.y + deltaY);
                const position = this.canvasLayout.rack_positions[this.canvasDrag.id];
                const zone = this.canvasZones.find(
                    (item: any) => String(Number(item?.id || 0)) === this.canvasDrag.zoneId
                );
                const zonePosition = zone ? this.canvasZonePosition(zone) : null;
                const maximumX = zonePosition && this.canvasScopeId === -1
                    ? Math.max(0, Number(zonePosition.width) - 130)
                    : 12000;
                const maximumY = zonePosition && this.canvasScopeId === -1
                    ? Math.max(0, Number(zonePosition.height) - 95)
                    : 12000;
                const offsetX = zonePosition && this.canvasScopeId === -1
                    ? Number(zonePosition.x) + 2
                    : 0;
                const offsetY = zonePosition && this.canvasScopeId === -1
                    ? Number(zonePosition.y) + 60
                    : 0;
                position.x = this.snapCanvasCoordinate(
                    offsetX + x,
                    offsetX,
                    offsetX + maximumX
                ) - offsetX;
                position.y = this.snapCanvasCoordinate(
                    offsetY + y,
                    offsetY,
                    offsetY + maximumY
                ) - offsetY;
            }
            this.canvasChanged = true;
            this.service.render();
            return;
        }
        if (this.canvasPanStart) {
            this.canvasPanX = this.canvasPanStart.x + event.clientX - this.canvasPanStart.clientX;
            this.canvasPanY = this.canvasPanStart.y + event.clientY - this.canvasPanStart.clientY;
            this.service.render();
        }
    }

    public onCanvasViewportMouseUp() {
        const shouldRender = Boolean(
            this.canvasDrawing
            || this.canvasObjectDrag
            || this.canvasDrag
            || this.canvasPanStart
        );
        this.finishCanvasObjectDrawing();
        this.canvasObjectDrag = null;
        this.canvasDrag = null;
        this.canvasPanStart = null;
        if (shouldRender) this.service.render();
    }

    public async openCanvasZone(zone: any) {
        if (this.canvasEdit) return;
        await this.loadCanvasScope(Number(zone?.id || 0));
    }

    public startCanvasItemDrag(event: DragEvent, item: any, rack: any) {
        if (!this.canvasEdit || this.canvasTool !== 'select' || this.canvasScopeId === -1) {
            event.preventDefault();
            return;
        }
        this.canvasDraggedItem = {
            key: `${item?.item_type || 'node'}:${Number(item?.id || 0)}`,
            item_type: ['device', 'chassis'].includes(String(item?.item_type || ''))
                ? String(item?.item_type)
                : 'node',
            id: Number(item?.id || 0),
            source_rack_id: Number(rack?.rack_record_id || 0),
            source_unit_order: Number(item?.unit_order || item?.unit || 1)
        };
        this.canvasDropShadow = null;
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', this.canvasDraggedItem.key);
        }
        this.service.render();
    }

    public endCanvasItemDrag() {
        this.canvasDraggedItem = null;
        this.canvasDropShadow = null;
        this.service.render();
    }

    public allowCanvasItemDrop(event: DragEvent, targetRack: any, unitOrder: number) {
        if (!this.canvasEdit || !this.canvasDraggedItem) return;
        event.preventDefault();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        const draggedItem = this.findCanvasItem(
            this.canvasDraggedItem.item_type,
            this.canvasDraggedItem.id
        );
        if (!draggedItem) return;
        const rackId = Number(targetRack?.rack_record_id || 0);
        const capacity = this.rackCapacity(targetRack);
        const itemSize = Math.max(
            1,
            Number(draggedItem?.unit_size || draggedItem?.rack_size || 1)
        );
        const previewUnit = Math.max(
            1,
            Math.min(
                Math.max(1, capacity - itemSize + 1),
                Math.round(Number(unitOrder))
            )
        );
        if (
            Number(this.canvasDropShadow?.rack_id || 0) === rackId
            && Number(this.canvasDropShadow?.unit || 0) === previewUnit
            && Number(this.canvasDropShadow?.unit_size || 0) === itemSize
        ) return;
        this.canvasDropShadow = {
            rack_id: rackId,
            unit: previewUnit,
            unit_size: itemSize,
            bottom: (previewUnit - 1) * this.canvasUnitHeight,
            height: Math.max(
                this.canvasUnitHeight - 1,
                itemSize * this.canvasUnitHeight - 1
            )
        };
        this.service.render();
    }

    public clearCanvasItemDropShadow(event: DragEvent, rack: any) {
        const currentTarget = event.currentTarget as HTMLElement | null;
        const relatedTarget = event.relatedTarget as Node | null;
        if (currentTarget && relatedTarget && currentTarget.contains(relatedTarget)) return;
        if (!this.isCanvasDropShadowRack(rack)) return;
        this.canvasDropShadow = null;
        this.service.render();
    }

    public canvasDropItem(event: DragEvent, targetRack: any, unitOrder: number) {
        event.preventDefault();
        event.stopPropagation();
        this.canvasDropShadow = null;
        if (!this.canvasEdit || !this.canvasDraggedItem || this.canvasScopeId === -1) return;

        const drag = this.canvasDraggedItem;
        const previousRacks = this.deepClone(this.canvasRacks);
        const previousMoves = this.deepClone(this.canvasMoves);
        const sourceRack = this.canvasRacks.find(
            (rack: any) => Number(rack?.rack_record_id || 0) === Number(drag.source_rack_id)
        );
        const draggedItem = this.findCanvasItem(drag.item_type, drag.id);
        if (!sourceRack || !draggedItem) return;

        const physicalUnit = Number(unitOrder);
        const targetOccupant = (targetRack?.items || []).find((item: any) => (
            !(item.item_type === drag.item_type && Number(item.id) === Number(drag.id))
            && physicalUnit >= Number(item?.unit_start || 0)
            && physicalUnit <= Number(item?.unit_end || 0)
        ));
        const targetUnitOrder = targetOccupant
            ? Number(targetOccupant?.unit_order || targetOccupant?.unit || 1)
            : this.canvasOrderForPhysicalUnit(targetRack, physicalUnit, draggedItem);
        if (targetOccupant) {
            this.moveCanvasItemLocal(
                targetOccupant,
                sourceRack,
                Number(drag.source_unit_order)
            );
            this.stageCanvasMove(
                targetOccupant,
                sourceRack,
                Number(drag.source_unit_order)
            );
        }
        this.moveCanvasItemLocal(draggedItem, targetRack, targetUnitOrder);
        this.stageCanvasMove(draggedItem, targetRack, targetUnitOrder);

        const valid = this.canvasRacks.every((rack: any) => this.reflowCanvasRack(rack));
        if (!valid) {
            this.canvasRacks = previousRacks;
            this.canvasMoves = previousMoves;
            this.canvasMessage = '선택한 위치는 Rack 용량을 초과하거나 다른 장비와 겹칩니다.';
        } else {
            this.canvasChanged = true;
            this.canvasMessage = `${draggedItem.name} 위치를 ${targetRack.name} U${physicalUnit}로 변경했습니다. 저장 버튼을 눌러 반영하세요.`;
        }
        this.canvasDraggedItem = null;
        this.service.render();
    }

    private findCanvasItem(itemType: string, itemId: number): any {
        for (const rack of this.canvasRacks) {
            const item = (rack?.items || []).find((candidate: any) => (
                candidate.item_type === itemType
                && Number(candidate.id) === Number(itemId)
            ));
            if (item) return item;
        }
        return null;
    }

    private canvasOrderForPhysicalUnit(rack: any, physicalUnit: number, draggedItem: any): number {
        const capacity = this.rackCapacity(rack);
        const itemType = draggedItem?.item_type || 'node';
        const itemId = Number(draggedItem?.id || 0);
        const itemSize = Math.max(
            1,
            Number(draggedItem?.unit_size || draggedItem?.rack_size || 1)
        );
        const existing = (rack?.items || []).filter((item: any) => !(
            item.item_type === itemType && Number(item.id) === itemId
        ));
        const usedOrders = new Set<number>(
            existing.map((item: any) => Number(item?.unit_order || item?.unit || 0))
        );
        let bestOrder = Math.max(1, Math.min(capacity, Math.round(physicalUnit)));
        let bestDistance = Number.MAX_SAFE_INTEGER;

        for (let candidateOrder = 1; candidateOrder <= capacity; candidateOrder += 1) {
            if (usedOrders.has(candidateOrder)) continue;
            const candidates = [
                ...existing,
                {
                    id: -1,
                    item_type: itemType,
                    unit_order: candidateOrder,
                    unit_size: itemSize
                }
            ].sort((left: any, right: any) => (
                Number(left?.unit_order || left?.unit || 0)
                - Number(right?.unit_order || right?.unit || 0)
            ));
            let extraUnits = 0;
            let candidateStart = candidateOrder;
            let valid = true;
            for (const item of candidates) {
                const order = Number(item?.unit_order || item?.unit || 0);
                if (order <= 0) continue;
                const size = Math.max(1, Number(item?.unit_size || item?.rack_size || 1));
                const start = order + extraUnits;
                const end = start + size - 1;
                if (Number(item.id) === -1) candidateStart = start;
                if (end > capacity) {
                    valid = false;
                    break;
                }
                extraUnits += size - 1;
            }
            if (!valid) continue;
            const distance = Math.abs(candidateStart - physicalUnit);
            if (distance < bestDistance) {
                bestDistance = distance;
                bestOrder = candidateOrder;
            }
        }
        return bestOrder;
    }

    private moveCanvasItemLocal(item: any, targetRack: any, unitOrder: number) {
        for (const rack of this.canvasRacks) {
            rack.items = (rack?.items || []).filter((candidate: any) => !(
                candidate.item_type === item.item_type
                && Number(candidate.id) === Number(item.id)
            ));
        }
        item.rack_record_id = Number(targetRack?.rack_record_id || 0);
        item.rack = String(targetRack?.rack_id || '');
        item.unit = unitOrder;
        item.unit_order = unitOrder;
        targetRack.items = targetRack.items || [];
        targetRack.items.push(item);
    }

    private stageCanvasMove(item: any, targetRack: any, unitOrder: number) {
        const key = `${item.item_type}:${Number(item.id)}`;
        this.canvasMoves[key] = {
            id: Number(item.id),
            item_type: item.item_type,
            rack_id: Number(targetRack?.rack_record_id || 0),
            unit_order: Number(unitOrder)
        };
    }

    private reflowCanvasRack(rack: any): boolean {
        const capacity = this.rackCapacity(rack);
        const items = (rack?.items || []).slice().sort((left: any, right: any) => (
            Number(left?.unit_order || left?.unit || 0)
            - Number(right?.unit_order || right?.unit || 0)
        ));
        const orders = new Set<number>();
        let extraUnits = 0;
        for (const item of items) {
            const order = Number(item?.unit_order || item?.unit || 0);
            if (order <= 0) continue;
            if (orders.has(order)) return false;
            orders.add(order);
            const size = Math.max(1, Number(item?.unit_size || item?.rack_size || 1));
            item.unit_start = order + extraUnits;
            item.unit_end = item.unit_start + size - 1;
            item.layout_overflow = item.unit_end > capacity;
            if (item.layout_overflow) return false;
            extraUnits += size - 1;
        }
        rack.items = items;
        rack.item_count = items.length;
        rack.server_count = items.filter(
            (item: any) => item.item_type === 'node',
        ).length + items
            .filter((item: any) => item.item_type === 'chassis')
            .reduce(
                (total: number, item: any) => total + Number(item?.node_count || 0),
                0,
            );
        rack.chassis_count = items.filter(
            (item: any) => item.item_type === 'chassis',
        ).length;
        rack.network_count = items.filter(
            (item: any) => item.item_type === 'device',
        ).length;
        return true;
    }

    public get canvasMoveCount(): number {
        return Object.keys(this.canvasMoves).length;
    }

    public isCanvasZoneDragging(zone: any): boolean {
        return Boolean(
            this.canvasDrag?.type === 'zone'
            && this.canvasDrag.id === String(Number(zone?.id || 0))
        );
    }

    public isCanvasRackDragging(rack: any): boolean {
        return Boolean(
            this.canvasDrag?.type === 'rack'
            && this.canvasDrag.id === String(Number(rack?.rack_record_id || 0))
        );
    }

    public isCanvasItemDragging(item: any): boolean {
        return Boolean(
            this.canvasDraggedItem
            && this.canvasDraggedItem.item_type === String(item?.item_type || 'node')
            && Number(this.canvasDraggedItem.id) === Number(item?.id || 0)
        );
    }

    public isCanvasDropShadowRack(rack: any): boolean {
        return Boolean(
            this.canvasDropShadow
            && Number(this.canvasDropShadow.rack_id) === Number(rack?.rack_record_id || 0)
        );
    }

    public canvasZoneSizeLabel(zone: any): string {
        const position = this.canvasZonePosition(zone);
        return `${Math.round(Number(position.width))} × ${Math.round(Number(position.height))} px`;
    }

    public canvasRackBodyHeight(rack: any): number {
        return this.rackCapacity(rack) * this.canvasUnitHeight;
    }

    public canvasItemBottom(item: any): number {
        return (Math.max(1, Number(item?.unit_start || 1)) - 1) * this.canvasUnitHeight;
    }

    public canvasItemHeight(item: any): number {
        const size = Math.max(1, Number(item?.unit_size || item?.rack_size || 1));
        return Math.max(this.canvasUnitHeight - 1, size * this.canvasUnitHeight - 1);
    }

    public formatUpdatedAt(): string {
        return this.formatDateTime(this.updatedAt);
    }

    public formatDateTime(value: any): string {
        if (!value) return '-';
        const date = new Date(String(value).replace(' ', 'T'));
        if (Number.isNaN(date.getTime())) return String(value);
        return date.toLocaleString();
    }

    public trackRack(_index: number, rack: any): string {
        return String(
            rack?.rack_key ||
            (rack?.rack_record_id ? `rack:${rack.rack_record_id}` : `${rack?.group_id || 0}:${rack?.rack_id || ''}`)
        );
    }

    public rackIdentity(rack: any): string {
        return String(
            rack?.rack_key ||
            (rack?.rack_record_id ? `rack:${rack.rack_record_id}` : `${rack?.group_id || 0}:${rack?.rack_id || ''}`)
        );
    }

    public trackItem(_index: number, item: any): string {
        return `${item?.item_type || 'item'}-${item?.id || _index}`;
    }
}

export default PageKieraProvisioningRackComponent;
